(function () {
  'use strict';

  var GLOBAL_KEY = '__blacklyteAiSceneGeneratorLoaded';
  if (window[GLOBAL_KEY]) return;
  window[GLOBAL_KEY] = true;

  var TYPE_ORDER = ['CHAIR', 'DESK', 'ACCESSORY'];
  var PRODUCT_PAYLOAD_COUNTS = { CHAIR: 12, DESK: 12, ACCESSORY: 12 };
  // Every product type uses the same reversed 12-frame mapping. The first
  // spin_images source maps to angle 0; sources 1..11 map to angles 11..1.
  var SPIN_SOURCE_INDEX_BY_ANGLE = [0, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
  var DEFAULT_ALLOWED_FORMATS = ['jpg', 'jpeg', 'png', 'webp', 'heic'];
  var DEFAULT_MAX_SIZE = 10 * 1024 * 1024;
  var AI_SCENE_API_CONFIG = {
    // Use 'dev' for direct backend debugging. Switch to 'production' before
    // publishing the live theme so requests go through Shopify App Proxy.
    environment: 'production',
    productionBaseUrl: '/apps/ai-scene/api/v1',
    developmentBaseUrl: 'https://dev-ai-platform-api.arcushome.cn/api/v1'
  };
  var DEFAULT_POLL_DELAY_SECONDS = 5;
  var DEFAULT_GENERATION_PROGRESS_DURATION_SECONDS = 150;
  var MIN_GENERATION_PROGRESS_DURATION_SECONDS = 30;
  var MAX_GENERATION_PROGRESS_DURATION_SECONDS = 600;
  var GENERATION_PROGRESS_START_PERCENT = 2;
  var GENERATION_PROGRESS_ESTIMATED_PERCENT = 92;
  var GENERATION_PROGRESS_MAX_PERCENT = 96;
  var GENERATION_PROGRESS_UPDATE_INTERVAL_MS = 250;
  var GENERATION_PROGRESS_COMPLETION_HOLD_MS = 400;
  var PROGRESS_PARTICLE_SPAWN_INTERVAL_MS = 110;
  var PROGRESS_PARTICLE_MIN_DURATION_MS = 1200;
  var PROGRESS_PARTICLE_MAX_DURATION_MS = 2200;
  var PROGRESS_PARTICLE_INITIAL_BURST_COUNT = 5;
  var PROGRESS_PARTICLE_MAX_COUNT = 72;
  var DEFAULT_PROCESSING_TIP = 'Large images may take a few minutes. We will keep checking the task status.';
  var PROCESSING_TIP_ROTATION_DELAY_MS = 4200;
  var PROCESSING_TIP_SLIDE_DURATION_MS = 240;
  var THEME_CART_REFRESH_TIMEOUT_MS = 8000;
  var STANDARD_UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  // Safety ceiling for a provider task that never leaves PROCESSING.
  var DEFAULT_GENERATION_POLL_TIMEOUT_MS = 10 * 60 * 1000;
  var VISITOR_STORAGE_KEY = 'blacklyte-ai-scene-visitor-token';
  var BROWSER_STORAGE_KEY = 'blacklyte-ai-scene-browser-id';
  var instances = new Map();
  var selectorBodyClassCount = 0;
  var mobileFullscreenBodyClassCount = 0;

  function normalizeUuid(value) {
    if (typeof value !== 'string') return '';
    var candidate = value.trim();
    return STANDARD_UUID_PATTERN.test(candidate) ? candidate.toLowerCase() : '';
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      try {
        var nativeUuid = normalizeUuid(window.crypto.randomUUID());
        if (nativeUuid) return nativeUuid;
      } catch (error) {
        // Fall through to the RFC 4122 version 4 formatter below.
      }
    }

    var bytes = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    var hex = Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }

  function storageGet(storage, key) {
    try {
      return storage && storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      if (storage) storage.setItem(key, value);
    } catch (error) {
      // Private browsing and blocked storage are valid storefront environments.
    }
  }

  function storageRemove(storage, key) {
    try {
      if (storage) storage.removeItem(key);
    } catch (error) {
      // Ignore storage failures; the in-memory token remains usable for this page.
    }
  }

  function currentIdentityGeneration() {
    var value = Number(window.__blacklyteAiIdentityGeneration || 0);
    return Number.isFinite(value) && value >= 0 ? value : 0;
  }

  function getBrowserId() {
    var current = normalizeUuid(storageGet(window.localStorage, BROWSER_STORAGE_KEY));
    if (current) {
      storageSet(window.localStorage, BROWSER_STORAGE_KEY, current);
      window.__blacklyteAiBrowserId = current;
      return current;
    }
    var shared = normalizeUuid(window.__blacklyteAiBrowserId);
    if (shared) {
      storageSet(window.localStorage, BROWSER_STORAGE_KEY, shared);
      window.__blacklyteAiBrowserId = shared;
      return shared;
    }
    var generated = uuid();
    storageSet(window.localStorage, BROWSER_STORAGE_KEY, generated);
    window.__blacklyteAiBrowserId = generated;
    return generated;
  }

  function getStoredVisitorToken() {
    var stored = storageGet(window.sessionStorage, VISITOR_STORAGE_KEY);
    if (stored) {
      window.__blacklyteAiVisitorToken = stored;
      return stored;
    }
    return typeof window.__blacklyteAiVisitorToken === 'string' ? window.__blacklyteAiVisitorToken : '';
  }

  function saveVisitorToken(token) {
    if (typeof token !== 'string' || !token) return;
    storageSet(window.sessionStorage, VISITOR_STORAGE_KEY, token);
    window.__blacklyteAiVisitorToken = token;
  }

  function clearVisitorToken() {
    storageRemove(window.sessionStorage, VISITOR_STORAGE_KEY);
    window.__blacklyteAiVisitorToken = '';
  }

  function normalizeType(value) {
    var type = String(value || '').toUpperCase();
    return TYPE_ORDER.indexOf(type) >= 0 ? type : '';
  }

  function historyProductNameKey(value) {
    return String(value || '').trim();
  }

  function normalizeCartProductType(value) {
    var type = String(value || '').trim().toUpperCase().replace(/[\s_-]+/g, '');
    if (type === 'CHAIR' || type === 'CHAIRS') return 'CHAIR';
    if (type === 'DESK' || type === 'DESKS') return 'DESK';
    if (type === 'ACCESSORY' || type === 'ACCESSORIES') return 'ACCESSORY';
    return '';
  }

  function imageContentType(file, extension) {
    var fileType = String(file && file.type || '').trim().toLowerCase();
    if (/^image\/[a-z0-9][a-z0-9.+-]*$/i.test(fileType)) return fileType;
    var extensionTypes = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      webp: 'image/webp',
      heic: 'image/heic'
    };
    return extensionTypes[String(extension || '').trim().toLowerCase()] || '';
  }

  function normalizeHttpsUrl(value) {
    if (!value) return '';
    var candidate = String(value).trim();
    if (candidate.indexOf('//') === 0) candidate = 'https:' + candidate;
    if (!/^https:\/\//i.test(candidate)) return '';
    try {
      var parsed = new URL(candidate);
      return parsed.protocol === 'https:' && !parsed.username && !parsed.password ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function normalizeSpinImageUrls(value) {
    var source = value;
    if (typeof source === 'string') {
      var serialized = source.trim();
      if (!serialized) return [];
      try {
        source = JSON.parse(serialized);
      } catch (error) {
        return [];
      }
    }
    if (!Array.isArray(source)) return [];
    return source.slice(0, SPIN_SOURCE_INDEX_BY_ANGLE.length).map(function (imageUrl) {
      return normalizeHttpsUrl(imageUrl);
    });
  }

  function buildChairNoShadowSpinImageUrl(value) {
    var normalized = normalizeHttpsUrl(value);
    if (!normalized) return '';
    try {
      var parsed = new URL(normalized);
      var dotComHostname = parsed.hostname
        .replace(/\.(?:com|co)\.[a-z]{2}$/i, '.com')
        .replace(/\.[a-z]{2}$/i, '.com');
      var lastSlashIndex = parsed.pathname.lastIndexOf('/');
      var filename = parsed.pathname.slice(lastSlashIndex + 1);
      if (!filename) return '';
      var extensionIndex = filename.lastIndexOf('.');
      var basename = extensionIndex > 0 ? filename.slice(0, extensionIndex) : filename;
      if (!basename) return '';
      if (!/-noshadow$/i.test(basename)) basename += '-noshadow';
      parsed.hostname = dotComHostname;
      parsed.pathname = parsed.pathname.slice(0, lastSlashIndex + 1) + basename + '.png';
      return normalizeHttpsUrl(parsed.href);
    } catch (error) {
      return '';
    }
  }

  function spinImageUrlsEqual(left, right) {
    return JSON.stringify(normalizeSpinImageUrls(left)) === JSON.stringify(normalizeSpinImageUrls(right));
  }

  function requiredProductPayloadCount(type) {
    return PRODUCT_PAYLOAD_COUNTS[normalizeType(type)] || 0;
  }

  function buildGenerationProductEntries(product) {
    var source = product && typeof product === 'object' ? product : {};
    var type = normalizeType(source.type);
    var fallbackImageUrl = normalizeHttpsUrl(source.imageUrl);
    var baseProduct = {
      type: type,
      name: String(source.name || '').slice(0, 256),
      imageUrl: fallbackImageUrl,
      productUrl: source.productUrl
    };
    if (!type) return [];
    var angleCount = requiredProductPayloadCount(type);
    var spinImageUrls = normalizeSpinImageUrls(source.spinImageUrls);
    var hasSpinImageUrls = spinImageUrls.some(function (imageUrl) { return Boolean(imageUrl); });
    if (type === 'CHAIR' && hasSpinImageUrls) {
      spinImageUrls = spinImageUrls.map(function (imageUrl) {
        return imageUrl ? buildChairNoShadowSpinImageUrl(imageUrl) : '';
      });
    }
    var products = [];
    for (var angleIndex = 0; angleIndex < angleCount; angleIndex += 1) {
      var sourceIndex = SPIN_SOURCE_INDEX_BY_ANGLE[angleIndex];
      products.push({
        type: baseProduct.type,
        name: baseProduct.name,
        imageUrl: spinImageUrls[sourceIndex] || fallbackImageUrl,
        productUrl: baseProduct.productUrl,
        angleIndex: angleIndex
      });
    }
    return products;
  }

  function normalizeStorefrontProductUrl(value, shopUrl) {
    var normalized = normalizeHttpsUrl(value);
    var normalizedShop = normalizeHttpsUrl(shopUrl);
    if (!normalized || !normalizedShop) return '';
    try {
      var productUrl = new URL(normalized);
      var storefrontUrl = new URL(normalizedShop);
      return productUrl.origin === storefrontUrl.origin ? productUrl.href : '';
    } catch (error) {
      return '';
    }
  }

  function getGlobalAiConfig() {
    var candidates = [window.BlacklyteAIConfig, window.blacklyteAIConfig];
    for (var i = 0; i < candidates.length; i += 1) {
      if (candidates[i] && typeof candidates[i] === 'object') return candidates[i];
    }
    return {};
  }

  function normalizeApiEnvironment(value) {
    var environment = String(value || '').trim().toLowerCase();
    return environment === 'dev' || environment === 'development' ? 'dev' : 'production';
  }

  function normalizeApiBase(value) {
    var globalConfig = getGlobalAiConfig();
    var environment = normalizeApiEnvironment(
      globalConfig.environment || globalConfig.env || AI_SCENE_API_CONFIG.environment
    );
    var environmentBaseUrl = environment === 'dev'
      ? AI_SCENE_API_CONFIG.developmentBaseUrl
      : AI_SCENE_API_CONFIG.productionBaseUrl;
    var configured = environment === 'dev' ? environmentBaseUrl : String(value || '').trim();
    if (environment !== 'dev' && !configured && typeof globalConfig.apiBaseUrl === 'string') {
      configured = globalConfig.apiBaseUrl.trim();
    }
    if (environment !== 'dev' && !configured && window.Shopify && typeof window.Shopify.aiSceneApiBaseUrl === 'string') {
      configured = window.Shopify.aiSceneApiBaseUrl.trim();
    }
    if (!configured) configured = environmentBaseUrl;

    var parsed;
    try {
      parsed = new URL(configured, window.location.origin);
    } catch (error) {
      return environmentBaseUrl;
    }
    if (
      parsed.username ||
      parsed.password ||
      parsed.search ||
      parsed.hash ||
      parsed.origin === 'null'
    ) {
      return environmentBaseUrl;
    }

    var path = (parsed.pathname || '').replace(/\/+$/, '');
    if (!/\/api\/v1$/i.test(path)) path += '/api/v1';
    var isSameOriginProxy = (
      parsed.origin === window.location.origin &&
      /^\/apps\/[^/]+(?:\/[^/]+)*\/api\/v1$/i.test(path)
    );
    var developmentApi = new URL(AI_SCENE_API_CONFIG.developmentBaseUrl);
    var developmentPath = developmentApi.pathname.replace(/\/+$/, '');
    var isDevelopmentApi = environment === 'dev' && parsed.origin === developmentApi.origin && path === developmentPath;
    if (!isSameOriginProxy && !isDevelopmentApi) return environmentBaseUrl;
    return isDevelopmentApi ? parsed.origin + path : path;
  }

  function asPositiveSeconds(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function parseProcessingTips(value) {
    return String(value || '')
      .replace(/<br\s*\/?>/gi, '\n')
      .split(/\r?\n/)
      .map(function (tip) { return tip.trim(); })
      .filter(Boolean);
  }

  function parseResponseBody(text) {
    if (!text) return {};
    try {
      return JSON.parse(text);
    } catch (error) {
      return {};
    }
  }

  function extractPayload(payload) {
    if (payload && payload.data && typeof payload.data === 'object') return payload.data;
    return payload || {};
  }

  function extractError(payload, fallbackMessage) {
    var root = payload && typeof payload === 'object' ? payload : {};
    var data = root.data && typeof root.data === 'object' ? root.data : {};
    var dataError = data.error && typeof data.error === 'object' ? data.error : {};
    var nestedError = root.error && typeof root.error === 'object' ? root.error : {};
    var source = Object.assign({}, root, data, dataError, nestedError);
    return {
      code: String(source.code || ''),
      message: String(source.message || fallbackMessage || ''),
      requestId: String(source.requestId || ''),
      limitScope: String(source.limitScope || ''),
      limitDimension: String(source.limitDimension || ''),
      limitPeriod: String(source.limitPeriod || '')
    };
  }

  function normalizeLimitField(value) {
    return String(value == null ? '' : value).trim().toUpperCase();
  }

  function isAbortError(error) {
    return error && (error.name === 'AbortError' || error.code === 'ABORT_ERR');
  }

  function tagError(error, phase) {
    if (error && (typeof error === 'object' || typeof error === 'function')) {
      error.aiScenePhase = phase;
      return error;
    }
    var wrapped = new Error(String(error || 'Request failed'));
    wrapped.aiScenePhase = phase;
    return wrapped;
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = Boolean(hidden);
  }

  function lockBodyScroll() {
    var count = Number(window.__blacklyteAiScrollLockCount || 0);
    if (count === 0) {
      window.__blacklyteAiPreviousBodyOverflow = document.body ? document.body.style.overflow : '';
      if (document.body) document.body.style.overflow = 'hidden';
    }
    window.__blacklyteAiScrollLockCount = count + 1;
  }

  function unlockBodyScroll() {
    var count = Number(window.__blacklyteAiScrollLockCount || 0);
    if (count <= 1) {
      window.__blacklyteAiScrollLockCount = 0;
      if (document.body) document.body.style.overflow = window.__blacklyteAiPreviousBodyOverflow || '';
      return;
    }
    window.__blacklyteAiScrollLockCount = count - 1;
  }

  function showSelectorBodyClass(instance) {
    if (instance.selectorBodyClassActive) return;
    instance.selectorBodyClassActive = true;
    selectorBodyClassCount += 1;
    if (document.body) document.body.classList.add('compare-modals-show');
  }

  function hideSelectorBodyClass(instance) {
    if (!instance.selectorBodyClassActive) return;
    instance.selectorBodyClassActive = false;
    selectorBodyClassCount = Math.max(0, selectorBodyClassCount - 1);
    if (selectorBodyClassCount === 0 && document.body) document.body.classList.remove('compare-modals-show');
  }

  function showMobileFullscreenBodyClass(instance) {
    if (instance.mobileFullscreenBodyClassActive) return;
    instance.mobileFullscreenBodyClassActive = true;
    mobileFullscreenBodyClassCount += 1;
    if (document.body) document.body.classList.add('ai-scene-generator-mobile-fullscreen');
    if (document.documentElement) document.documentElement.classList.add('ai-scene-generator-mobile-fullscreen');
  }

  function hideMobileFullscreenBodyClass(instance) {
    if (!instance.mobileFullscreenBodyClassActive) return;
    instance.mobileFullscreenBodyClassActive = false;
    mobileFullscreenBodyClassCount = Math.max(0, mobileFullscreenBodyClassCount - 1);
    if (mobileFullscreenBodyClassCount === 0 && document.body) {
      document.body.classList.remove('ai-scene-generator-mobile-fullscreen');
    }
    if (mobileFullscreenBodyClassCount === 0 && document.documentElement) {
      document.documentElement.classList.remove('ai-scene-generator-mobile-fullscreen');
    }
  }

  function focusableWithin(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(
      'button:not([disabled]), a[href]:not([aria-disabled="true"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      var current = element;
      while (current && current !== container) {
        if (current.hidden || current.getAttribute('aria-hidden') === 'true') return false;
        current = current.parentElement;
      }
      return true;
    });
  }

  function wait(ms, signal) {
    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(resolve, Math.max(0, ms));
      if (!signal) return;
      if (signal.aborted) {
        window.clearTimeout(timer);
        reject(new DOMException('The operation was aborted.', 'AbortError'));
        return;
      }
      signal.addEventListener('abort', function () {
        window.clearTimeout(timer);
        reject(new DOMException('The operation was aborted.', 'AbortError'));
      }, { once: true });
    });
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function cloneMap(source) {
    var result = new Map();
    source.forEach(function (value, key) {
      result.set(key, Object.assign({}, value));
    });
    return result;
  }

  function selectionMapsEqual(left, right) {
    if (!left || !right || left.size !== right.size) return false;
    var equal = true;
    left.forEach(function (value, key) {
      var other = right.get(key);
      if (
        !value ||
        !other ||
        value.optionKey !== other.optionKey ||
        value.type !== other.type ||
        value.name !== other.name ||
        value.imageUrl !== other.imageUrl ||
        !spinImageUrlsEqual(value.spinImageUrls, other.spinImageUrls)
      ) {
        equal = false;
      }
    });
    return equal;
  }

  function createApiError(status, payload, fallbackMessage, headers) {
    var detail = extractError(payload, fallbackMessage);
    var error = new Error(detail.message || fallbackMessage || 'Request failed');
    error.name = 'AiSceneApiError';
    error.status = status;
    error.code = detail.code;
    error.headers = headers;
    error.payload = payload;
    error.requestId = detail.requestId || String(payload && payload.requestId || '');
    error.limitScope = detail.limitScope;
    error.limitDimension = detail.limitDimension;
    error.limitPeriod = detail.limitPeriod;
    return error;
  }

  function getRootFromEventTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-ai-scene-generator]');
  }

  function findSectionRoot(target) {
    if (!target) return null;
    if (target.matches && target.matches('[data-ai-scene-generator]')) return target;
    if (target.querySelector) return target.querySelector('[data-ai-scene-generator]');
    return null;
  }

  function AiSceneGenerator(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId || root.id || uuid();
    this.shopUrl = normalizeHttpsUrl(root.dataset.shopUrl) || normalizeHttpsUrl(window.location.origin);
    this.apiBase = normalizeApiBase(root.dataset.apiBaseUrl);
    var configuredProgressDuration = Number(root.dataset.generationProgressDurationSeconds);
    if (!Number.isFinite(configuredProgressDuration) || configuredProgressDuration <= 0) {
      configuredProgressDuration = DEFAULT_GENERATION_PROGRESS_DURATION_SECONDS;
    }
    configuredProgressDuration = Math.min(
      MAX_GENERATION_PROGRESS_DURATION_SECONDS,
      Math.max(MIN_GENERATION_PROGRESS_DURATION_SECONDS, configuredProgressDuration)
    );
    this.generationProgressDurationMs = configuredProgressDuration * 1000;
    this.processingTips = parseProcessingTips(root.dataset.labelProcessingTip);
    if (!this.processingTips.length) this.processingTips = [DEFAULT_PROCESSING_TIP];
    this.labels = {
      roomProduct: root.dataset.labelRoomProduct || 'Room Product',
      cartProduct: root.dataset.labelCartProduct || 'Cart Product',
      chair: root.dataset.labelChair || 'Chair',
      desk: root.dataset.labelDesk || 'Desk',
      accessories: root.dataset.labelAccessories || 'Accessories',
      upload: root.dataset.labelUpload || 'Upload background',
      generate: root.dataset.labelGenerate || 'Generate matching image',
      addToCart: root.dataset.labelAddToCart || 'Add to cart',
      selectProduct: root.dataset.labelSelectProduct || 'Select product',
      noProduct: root.dataset.labelNoProduct || 'Select at least one product to continue.',
      cartEmpty: root.dataset.labelCartEmpty || 'Your cart is empty. Switch to choose products.',
      cartUnavailable: root.dataset.labelCartUnavailable || 'No cart products are available for AI matching. Switch to Room Product to choose products.',
      cartRefreshing: root.dataset.labelCartRefreshing || 'Refreshing your cart…',
      cartRefreshFailed: root.dataset.labelCartRefreshFailed || 'We could not refresh your cart. Retry before generating.',
      cartItemUnavailable: root.dataset.labelCartItemUnavailable || 'Not available for AI matching',
      cartRetry: root.dataset.labelCartRetry || 'Retry cart',
      processing: root.dataset.labelProcessing || 'Matching your room',
      processingTip: this.processingTips[0],
      success: root.dataset.labelSuccess || 'Your matching image is ready',
      failed: root.dataset.labelFailed || 'Something went wrong. Please try again.',
      unknown: root.dataset.labelUnknown || 'We could not confirm the final result. You can try again.',
      retry: root.dataset.labelRetry || 'Generate again',
      download: root.dataset.labelDownload || 'Download',
      change: root.dataset.labelChange || 'Change',
      close: root.dataset.labelClose || 'Close',
      confirm: root.dataset.labelConfirm || 'Confirm',
      takePhoto: root.dataset.labelTakePhoto || 'Take a photo',
      chooseAlbum: root.dataset.labelChooseAlbum || 'Choose from album',
      emailSent: root.dataset.labelEmailSent || 'Your image has been queued for email delivery.',
      noHistory: root.dataset.labelNoHistory || 'Your recent room photos will appear here.'
    };
    this.loginUrl = String(root.dataset.loginUrl || '').trim();
    this.inlineLoginAvailable = root.dataset.inlineLoginAvailable === 'true';
    this.customerLoggedIn = root.dataset.customerLoggedIn === 'true';
    this.baseState = 'EMPTY';
    this.overlayState = '';
    this.uploadAuth = null;
    this.uploadAuthorizationPromise = null;
    this.visitorToken = getStoredVisitorToken();
    this.identityGeneration = currentIdentityGeneration();
    getBrowserId();
    this.room = {
      previewUrl: '',
      objectKey: '',
      uploadSessionId: '',
      identityGeneration: this.identityGeneration,
      fileName: '',
      file: null
    };
    this.resultUrl = '';
    this.selected = new Map();
    this.draftSelections = new Map();
    this.products = [];
    this.cartProducts = [];
    this.cartSelections = new Map();
    this.mainTab = 'room';
    this.cartRefreshPending = false;
    this.cartRefreshDirty = false;
    this.cartRefreshController = null;
    this.deferredCartProducts = null;
    this.pendingGenerationProducts = null;
    this.uploadHistory = [];
    this.pendingHistory = null;
    this.generationHistory = [];
    this.generationHistoryNextCursor = '';
    this.generationHistoryHasMore = false;
    this.generationHistoryLoadPromise = null;
    this.generation = null;
    this.abortControllers = new Set();
    this.uploadRequestId = 0;
    this.generationPending = false;
    this.emailDeliveryPending = false;
    this.cartAddPending = false;
    this.overlayFocus = null;
    this.overlayLock = false;
    this.selectorBodyClassActive = false;
    this.mobileFullscreenBodyClassActive = false;
    this.thumbnailPointerId = null;
    this.thumbnailDragStartX = 0;
    this.thumbnailDragStartScrollLeft = 0;
    this.thumbnailDragActive = false;
    this.thumbnailSuppressClick = false;
    this.thumbnailSuppressClickTimer = 0;
    this.processingTipIndex = 0;
    this.processingTipInterval = 0;
    this.processingTipSwapTimer = 0;
    this.processingTipAnimationTimer = 0;
    this.generationProgress = 0;
    this.generationProgressRounded = -1;
    this.generationProgressStartedAt = 0;
    this.generationProgressInterval = 0;
    this.progressParticleInterval = 0;
    this.progressParticleCleanupTimers = new Set();
    this.progressParticleSequence = 0;
    this.mobileViewportFrame = 0;
    this.mobileViewportOffset = null;
    this.mobileViewportResizeObserver = null;
    this.mobileViewportWatchTargets = [];
    this.mobileViewportMutationObserver = null;
    this.onMobileViewportChangeBound = null;
    this.selectorType = 'CHAIR';
    this.bound = false;
    this.destroyed = false;
    this.cacheNodes();
    this.readProducts();
    this.readCartProducts();
    this.bind();
    this.renderAll();
    showMobileFullscreenBodyClass(this);
    this.bindMobileViewport();
    this.loadGenerationHistory();
  }

  AiSceneGenerator.prototype.cacheNodes = function () {
    var root = this.root;
    this.nodes = {
      stage: root.querySelector('[data-stage]'),
      emptyState: root.querySelector('[data-empty-state]'),
      exampleImage: root.querySelector('[data-example-image]'),
      roomImage: root.querySelector('[data-room-image]'),
      resultImage: root.querySelector('[data-result-image]'),
      resultDisclaimer: root.querySelector('[data-result-disclaimer]'),
      stageChange: root.querySelector('[data-stage-change]'),
      processingOverlay: root.querySelector('[data-processing-overlay]'),
      progressParticles: root.querySelector('[data-progress-particles]'),
      processingProducts: root.querySelector('[data-processing-products]'),
      generationProgress: root.querySelector('[data-generation-progress]'),
      generationProgressFill: root.querySelector('[data-generation-progress-fill]'),
      generationProgressValue: root.querySelector('[data-generation-progress-value]'),
      generationProgressStatus: root.querySelector('[data-generation-progress-status]'),
      processingTipText: root.querySelector('[data-processing-tip-text]'),
      stageStatus: root.querySelector('[data-stage-status]'),
      thumbnails: root.querySelector('[data-thumbnail-list]'),
      thumbnailUpload: root.querySelector('[data-thumbnail-upload]'),
      error: root.querySelector('[data-error-message]'),
      productRequirement: root.querySelector('[data-product-requirement]'),
      panelStatus: root.querySelector('[data-panel-status]'),
      cartStatus: root.querySelector('[data-cart-status]'),
      cartEmpty: root.querySelector('[data-cart-empty]'),
      cartList: root.querySelector('[data-cart-list]'),
      selectedIconTemplate: root.querySelector('[data-selected-icon-template]'),
      productSelector: root.querySelector('[data-product-selector]'),
      selectorDialog: root.querySelector('[data-product-selector] [role="dialog"]'),
      uploadDrawer: root.querySelector('[data-upload-drawer]'),
      uploadDialog: root.querySelector('[data-upload-drawer] [role="dialog"]'),
      historyList: root.querySelector('[data-history-list]'),
      historyEmpty: root.querySelector('[data-history-empty]'),
      uploadStatus: root.querySelector('[data-upload-status]'),
      confirmUpload: root.querySelector('[data-confirm-upload]'),
      panelDefaultActions: root.querySelector('[data-panel-default-actions]'),
      panelResultActions: root.querySelector('[data-panel-result-actions]'),
      panelActionStatus: root.querySelector('[data-panel-action-status]'),
      addSelectedToCartButtons: root.querySelectorAll('[data-add-selected-to-cart]'),
      mobileDownload: root.querySelector('[data-mobile-download]'),
      emailDeliveryModal: root.querySelector('[data-email-delivery-modal]'),
      emailDeliveryDialog: root.querySelector('[data-email-delivery-modal] [role="dialog"]'),
      emailDeliveryForm: root.querySelector('[data-email-delivery-form]'),
      emailDeliveryInput: root.querySelector('[data-email-delivery-input]'),
      emailDeliverySubmit: root.querySelector('[data-email-delivery-submit]'),
      emailDeliveryStatus: root.querySelector('[data-email-delivery-status]'),
      dailyLimitModal: root.querySelector('[data-daily-limit-modal]'),
      dailyLimitDialog: root.querySelector('[data-daily-limit-modal] [role="dialog"]'),
      dailyLimitLogin: root.querySelector('[data-daily-limit-login]')
    };
    this.fileInputs = {
      album: root.querySelector('[data-file-input="album"]'),
      camera: root.querySelector('[data-file-input="camera"]')
    };
  };

  AiSceneGenerator.prototype.readProducts = function () {
    var optionNodes = this.root.querySelectorAll('[data-product-option]');
    var shopUrl = this.shopUrl;
    this.products = Array.prototype.map.call(optionNodes, function (node) {
      var imageUrl = normalizeHttpsUrl(node.dataset.productImageUrl);
      var productUrl = normalizeStorefrontProductUrl(node.dataset.productUrl, shopUrl);
      var variantId = String(node.dataset.variantId || '').trim();
      return {
        blockId: node.dataset.blockId || '',
        optionKey: node.dataset.productOptionKey || node.dataset.blockId || '',
        type: normalizeType(node.dataset.productType),
        name: String(node.dataset.productName || '').trim(),
        title: String(node.dataset.productTitle || node.dataset.productName || '').trim(),
        variantTitle: String(node.dataset.productVariantTitle || '').trim(),
        imageUrl: imageUrl,
        spinImageUrls: normalizeSpinImageUrls(node.dataset.productSpinImageUrls),
        productUrl: productUrl,
        variantId: /^\d+$/.test(variantId) ? variantId : '',
        purchasable: node.dataset.productPurchasable === 'true',
        preorderInfo: String(node.dataset.preorderInfo || '').trim(),
        available: node.dataset.productAvailable === 'true' && Boolean(imageUrl && productUrl),
        node: node
      };
    }).filter(function (product) {
      return product.type && product.optionKey;
    });
  };

  AiSceneGenerator.prototype.parseCartProducts = function (sourceNode, strict) {
    var node = sourceNode || this.root.querySelector('[data-cart-products]');
    var rawProducts = [];
    if (node) {
      try {
        var parsed = JSON.parse(node.textContent || '[]');
        if (!Array.isArray(parsed)) throw new Error('Cart product data must be an array.');
        rawProducts = parsed;
      } catch (error) {
        if (strict) throw new Error('Cart product data is invalid.');
        rawProducts = [];
      }
    }
    return rawProducts.map(function (item, index) {
      var product = item && typeof item === 'object' ? item : {};
      var imageUrl = normalizeHttpsUrl(product.imageUrl);
      var productUrl = normalizeStorefrontProductUrl(product.productUrl, this.shopUrl);
      var type = normalizeCartProductType(product.productType);
      var name = String(product.name || '').trim();
      var productTitle = String(product.productTitle || '').trim();
      var variantTitle = String(product.variantTitle || '').trim();
      if (/^default title$/i.test(variantTitle)) variantTitle = '';
      var variantId = String(product.variantId || '').trim();
      var lineKey = String(product.lineKey || '').trim();
      var cartProductName = name || productTitle;
      var normalizedName = cartProductName || 'Cart product';
      return {
        optionKey: 'cart-' + (lineKey || (/^\d+$/.test(variantId) ? variantId : String(index))),
        lineKey: lineKey,
        type: type,
        rawType: String(product.productType || '').trim(),
        name: normalizedName,
        productTitle: productTitle || normalizedName,
        variantTitle: variantTitle,
        imageUrl: imageUrl,
        spinImageUrls: normalizeSpinImageUrls(product.spinImageUrls),
        productUrl: productUrl,
        variantId: /^\d+$/.test(variantId) ? variantId : '',
        purchasable: true,
        preorderInfo: String(product.preorderInfo || '').trim(),
        quantity: Math.max(1, Number(product.quantity) || 1),
        available: Boolean(type && imageUrl && productUrl && cartProductName)
      };
    }, this);
  };

  AiSceneGenerator.prototype.readCartProducts = function (sourceNode) {
    this.cartProducts = this.parseCartProducts(sourceNode);
  };

  AiSceneGenerator.prototype.bind = function () {
    if (this.bound) return;
    this.bound = true;
    this.onClickBound = this.onClick.bind(this);
    this.onChangeBound = this.onChange.bind(this);
    this.onSubmitBound = this.onSubmit.bind(this);
    this.onKeydownBound = this.onKeydown.bind(this);
    this.onCartUpdateBound = this.onCartUpdate.bind(this);
    this.onGeneratedImageContextMenuBound = this.onGeneratedImageContextMenu.bind(this);
    this.root.addEventListener('click', this.onClickBound);
    this.root.addEventListener('change', this.onChangeBound);
    this.root.addEventListener('submit', this.onSubmitBound);
    this.root.addEventListener('contextmenu', this.onGeneratedImageContextMenuBound);
    document.addEventListener('keydown', this.onKeydownBound);
    document.addEventListener('cart-update', this.onCartUpdateBound);
    this.bindThumbnailScroller();
  };

  AiSceneGenerator.prototype.bindThumbnailScroller = function () {
    var list = this.nodes && this.nodes.thumbnails;
    if (!list) return;

    this.onThumbnailPointerDownBound = this.onThumbnailPointerDown.bind(this);
    this.onThumbnailPointerMoveBound = this.onThumbnailPointerMove.bind(this);
    this.onThumbnailPointerUpBound = this.onThumbnailPointerUp.bind(this);
    this.onThumbnailWheelBound = this.onThumbnailWheel.bind(this);
    list.addEventListener('pointerdown', this.onThumbnailPointerDownBound);
    list.addEventListener('pointermove', this.onThumbnailPointerMoveBound, { passive: false });
    list.addEventListener('pointerup', this.onThumbnailPointerUpBound);
    list.addEventListener('pointercancel', this.onThumbnailPointerUpBound);
    list.addEventListener('lostpointercapture', this.onThumbnailPointerUpBound);
    list.addEventListener('wheel', this.onThumbnailWheelBound, { passive: false });
    document.addEventListener('pointerup', this.onThumbnailPointerUpBound, true);
    document.addEventListener('pointercancel', this.onThumbnailPointerUpBound, true);
  };

  AiSceneGenerator.prototype.unbindThumbnailScroller = function () {
    var list = this.nodes && this.nodes.thumbnails;
    if (list) {
      list.removeEventListener('pointerdown', this.onThumbnailPointerDownBound);
      list.removeEventListener('pointermove', this.onThumbnailPointerMoveBound);
      list.removeEventListener('pointerup', this.onThumbnailPointerUpBound);
      list.removeEventListener('pointercancel', this.onThumbnailPointerUpBound);
      list.removeEventListener('lostpointercapture', this.onThumbnailPointerUpBound);
      list.removeEventListener('wheel', this.onThumbnailWheelBound);
      list.classList.remove('is-dragging');
    }
    if (this.onThumbnailPointerUpBound) {
      document.removeEventListener('pointerup', this.onThumbnailPointerUpBound, true);
      document.removeEventListener('pointercancel', this.onThumbnailPointerUpBound, true);
    }
    if (this.thumbnailSuppressClickTimer) {
      window.clearTimeout(this.thumbnailSuppressClickTimer);
      this.thumbnailSuppressClickTimer = 0;
    }
    this.thumbnailPointerId = null;
    this.thumbnailDragActive = false;
    this.thumbnailSuppressClick = false;
  };

  AiSceneGenerator.prototype.onThumbnailPointerDown = function (event) {
    var list = this.nodes && this.nodes.thumbnails;
    if (!list || this.destroyed || event.pointerType !== 'mouse' || event.button !== 0) return;
    if (this.thumbnailSuppressClickTimer) {
      window.clearTimeout(this.thumbnailSuppressClickTimer);
      this.thumbnailSuppressClickTimer = 0;
    }
    this.thumbnailSuppressClick = false;
    if (list.scrollWidth <= list.clientWidth + 1) return;

    this.thumbnailPointerId = event.pointerId;
    this.thumbnailDragStartX = event.clientX;
    this.thumbnailDragStartScrollLeft = list.scrollLeft;
    this.thumbnailDragActive = false;
  };

  AiSceneGenerator.prototype.onThumbnailPointerMove = function (event) {
    var list = this.nodes && this.nodes.thumbnails;
    if (!list || this.thumbnailPointerId === null || event.pointerId !== this.thumbnailPointerId) return;
    if (event.buttons === 0) {
      this.onThumbnailPointerUp(event);
      return;
    }

    var delta = event.clientX - this.thumbnailDragStartX;
    var viewportWidth = Number(window.innerWidth) || 1024;
    var threshold = Math.max(6, Math.min(12, viewportWidth * 0.005));
    if (!this.thumbnailDragActive && Math.abs(delta) <= threshold) return;

    if (!this.thumbnailDragActive) {
      this.thumbnailDragActive = true;
      list.classList.add('is-dragging');
      if (typeof list.setPointerCapture === 'function') {
        try {
          list.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture is optional; the native scroll position still works.
        }
      }
    }
    list.scrollLeft = this.thumbnailDragStartScrollLeft - delta;
    event.preventDefault();
  };

  AiSceneGenerator.prototype.onThumbnailPointerUp = function (event) {
    var list = this.nodes && this.nodes.thumbnails;
    if (!list || this.thumbnailPointerId === null) return;
    if (event.pointerId != null && event.pointerId !== this.thumbnailPointerId) return;

    var pointerId = this.thumbnailPointerId;
    var wasDragged = this.thumbnailDragActive;
    this.thumbnailPointerId = null;
    this.thumbnailDragActive = false;
    list.classList.remove('is-dragging');
    if (typeof list.hasPointerCapture === 'function' && list.hasPointerCapture(pointerId)) {
      try {
        list.releasePointerCapture(pointerId);
      } catch (error) {
        // The browser may release capture before pointerup/pointercancel.
      }
    }

    if (!wasDragged) return;
    this.thumbnailSuppressClick = true;
    if (this.thumbnailSuppressClickTimer) window.clearTimeout(this.thumbnailSuppressClickTimer);
    var self = this;
    this.thumbnailSuppressClickTimer = window.setTimeout(function () {
      self.thumbnailSuppressClick = false;
      self.thumbnailSuppressClickTimer = 0;
    }, 300);
  };

  AiSceneGenerator.prototype.onThumbnailWheel = function (event) {
    var list = this.nodes && this.nodes.thumbnails;
    if (!list || event.ctrlKey || event.metaKey || list.scrollWidth <= list.clientWidth + 1) return;

    var deltaMultiplier = 1;
    if (event.deltaMode === 1) deltaMultiplier = 16;
    if (event.deltaMode === 2) deltaMultiplier = list.clientWidth || 1;
    var deltaX = (Number(event.deltaX) || 0) * deltaMultiplier;
    var deltaY = (Number(event.deltaY) || 0) * deltaMultiplier;
    var delta = Math.abs(deltaX) >= Math.abs(deltaY) ? deltaX : deltaY;
    if (!delta) return;
    var previousScrollLeft = list.scrollLeft;
    list.scrollLeft += delta;
    if (list.scrollLeft !== previousScrollLeft) event.preventDefault();
  };

  AiSceneGenerator.prototype.onGeneratedImageContextMenu = function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-generated-image]')) event.preventDefault();
  };

  AiSceneGenerator.prototype.mobileViewportHeaderNodes = function () {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.announcement-bar, .section-header-mobile'));
    return nodes.filter(function (node, index, list) {
      return node && list.indexOf(node) === index;
    });
  };

  AiSceneGenerator.prototype.mobileViewportResizeTargets = function () {
    var targets = [];
    var addTarget = function (target) {
      if (target && targets.indexOf(target) < 0) targets.push(target);
    };

    this.mobileViewportHeaderNodes().forEach(function (node) {
      addTarget(node);
      if (node.parentElement && node.parentElement !== document.body) addTarget(node.parentElement);
      if (node.closest) addTarget(node.closest('.shopify-section'));
    });
    document.querySelectorAll('.shopify-section-group-header-group').forEach(addTarget);
    var mainContent = document.getElementById('MainContent');
    addTarget(mainContent);
    return targets;
  };

  AiSceneGenerator.prototype.refreshMobileViewportObservers = function () {
    var targets = this.mobileViewportResizeTargets();
    if (this.mobileViewportResizeObserver) {
      this.mobileViewportResizeObserver.disconnect();
      this.mobileViewportWatchTargets = targets;
      targets.forEach(function (target) {
        this.mobileViewportResizeObserver.observe(target);
      }, this);
    }
    this.refreshMobileViewportMutationObserver();
  };

  AiSceneGenerator.prototype.refreshMobileViewportMutationObserver = function () {
    if (!this.mobileViewportMutationObserver) return;
    this.mobileViewportMutationObserver.disconnect();
    var observedTargets = [];
    var addTarget = function (target) {
      if (target && observedTargets.indexOf(target) < 0) observedTargets.push(target);
    };

    document.querySelectorAll('.shopify-section-group-header-group').forEach(addTarget);
    this.mobileViewportHeaderNodes().forEach(function (node) {
      if (node.parentElement && node.parentElement !== document.body) addTarget(node.parentElement);
      if (node.closest) addTarget(node.closest('.shopify-section'));
    });

    observedTargets.forEach(function (target) {
      this.mobileViewportMutationObserver.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    }, this);

    if (document.body && observedTargets.indexOf(document.body) < 0) {
      this.mobileViewportMutationObserver.observe(document.body, { childList: true });
    }
  };

  AiSceneGenerator.prototype.calculateMobileTopOffset = function () {
    var mainContent = document.getElementById('MainContent');
    var layoutAnchor = mainContent && mainContent.contains(this.root) ? mainContent : this.root;
    var offset = Math.max(0, layoutAnchor.getBoundingClientRect().top);
    var viewportHeight = window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;

    if (offset <= 0) {
      this.mobileViewportHeaderNodes().forEach(function (node) {
        var style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden') return;

        var rect = node.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0 || (viewportHeight && rect.top >= viewportHeight)) return;
        offset = Math.max(offset, rect.bottom);
      });
    }

    if (viewportHeight > 0) offset = Math.min(offset, viewportHeight);

    return Math.max(0, Math.ceil(offset * 100) / 100);
  };

  AiSceneGenerator.prototype.updateMobileViewportOffset = function () {
    if (this.destroyed) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 767px)').matches) {
      if (this.mobileViewportOffset !== null) {
        this.root.style.removeProperty('--ai-mobile-top-offset');
        this.mobileViewportOffset = null;
      }
      return;
    }

    var offset = this.calculateMobileTopOffset();
    if (offset === this.mobileViewportOffset) return;
    this.mobileViewportOffset = offset;
    this.root.style.setProperty('--ai-mobile-top-offset', offset + 'px');
  };

  AiSceneGenerator.prototype.scheduleMobileViewportUpdate = function () {
    if (this.destroyed || this.mobileViewportFrame) return;
    var self = this;
    this.mobileViewportFrame = window.requestAnimationFrame(function () {
      self.mobileViewportFrame = 0;
      self.updateMobileViewportOffset();
    });
  };

  AiSceneGenerator.prototype.bindMobileViewport = function () {
    var self = this;
    this.onMobileViewportChangeBound = this.scheduleMobileViewportUpdate.bind(this);
    window.addEventListener('resize', this.onMobileViewportChangeBound);
    window.addEventListener('orientationchange', this.onMobileViewportChangeBound);
    window.addEventListener('scroll', this.onMobileViewportChangeBound, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.onMobileViewportChangeBound);
      window.visualViewport.addEventListener('scroll', this.onMobileViewportChangeBound);
    }

    if (typeof window.ResizeObserver === 'function') {
      this.mobileViewportResizeObserver = new window.ResizeObserver(this.onMobileViewportChangeBound);
      this.refreshMobileViewportObservers();
    }

    if (typeof window.MutationObserver === 'function') {
      this.mobileViewportMutationObserver = new window.MutationObserver(function () {
        self.refreshMobileViewportObservers();
        self.scheduleMobileViewportUpdate();
      });
      this.refreshMobileViewportMutationObserver();
    }

    this.updateMobileViewportOffset();
  };

  AiSceneGenerator.prototype.unbindMobileViewport = function () {
    window.removeEventListener('resize', this.onMobileViewportChangeBound);
    window.removeEventListener('orientationchange', this.onMobileViewportChangeBound);
    window.removeEventListener('scroll', this.onMobileViewportChangeBound);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.onMobileViewportChangeBound);
      window.visualViewport.removeEventListener('scroll', this.onMobileViewportChangeBound);
    }
    if (this.mobileViewportResizeObserver) {
      this.mobileViewportResizeObserver.disconnect();
      this.mobileViewportResizeObserver = null;
    }
    if (this.mobileViewportMutationObserver) {
      this.mobileViewportMutationObserver.disconnect();
      this.mobileViewportMutationObserver = null;
    }
    if (this.mobileViewportFrame) {
      window.cancelAnimationFrame(this.mobileViewportFrame);
      this.mobileViewportFrame = 0;
    }
    this.mobileViewportWatchTargets = [];
    this.mobileViewportOffset = null;
    this.root.style.removeProperty('--ai-mobile-top-offset');
  };

  AiSceneGenerator.prototype.onCartUpdate = function () {
    this.cartRefreshDirty = true;
    this.renderAll();
    this.refreshCartProducts();
  };

  AiSceneGenerator.prototype.onClick = function (event) {
    var target = event.target;
    var thumbnailList = this.nodes && this.nodes.thumbnails;
    var thumbnailClick = Boolean(thumbnailList && target && thumbnailList.contains(target));
    if (this.thumbnailSuppressClick && thumbnailClick) {
      event.preventDefault();
      event.stopPropagation();
      this.thumbnailSuppressClick = false;
      if (this.thumbnailSuppressClickTimer) {
        window.clearTimeout(this.thumbnailSuppressClickTimer);
        this.thumbnailSuppressClickTimer = 0;
      }
      return;
    }
    if (target && target.matches && target.matches('[data-email-delivery-modal]')) {
      event.preventDefault();
      this.closeEmailDelivery(true);
      return;
    }
    if (target && target.matches && target.matches('[data-daily-limit-modal]')) {
      event.preventDefault();
      this.closeDailyLimit(true);
      return;
    }
    var action = target.closest ? target.closest('button, a') : null;
    if (!action || !this.root.contains(action)) return;

    if (action.matches('[data-upload-trigger]')) {
      event.preventDefault();
      this.triggerUpload(action.dataset.uploadTrigger || 'album');
      return;
    }

    if (action.matches('[data-mobile-open-products]')) {
      event.preventDefault();
      this.openSelector(this.selectorType);
      return;
    }

    if (action.matches('[data-mobile-open-upload]')) {
      event.preventDefault();
      this.openUploadDrawer();
      return;
    }

    if (action.matches('[data-open-selector]')) {
      event.preventDefault();
      this.openSelector(normalizeType(action.dataset.type));
      return;
    }

    if (action.matches('[data-main-tab]')) {
      event.preventDefault();
      this.switchMainTab(action.dataset.mainTab);
      return;
    }

    if (action.matches('[data-switch-main-tab]')) {
      event.preventDefault();
      this.switchMainTab(action.dataset.switchMainTab);
      return;
    }

    if (action.matches('[data-cart-product]')) {
      event.preventDefault();
      this.toggleCartProduct(action);
      return;
    }

    if (action.matches('[data-refresh-cart]')) {
      event.preventDefault();
      this.refreshCartProducts();
      return;
    }

    if (action.matches('[data-selector-tab]')) {
      event.preventDefault();
      this.switchSelectorTab(normalizeType(action.dataset.selectorTab));
      return;
    }

    if (action.matches('[data-product-tile]')) {
      event.preventDefault();
      this.toggleDraftProduct(action);
      return;
    }

    if (action.matches('[data-confirm-selector]')) {
      event.preventDefault();
      this.confirmSelector();
      return;
    }

    if (action.matches('[data-close-selector]')) {
      event.preventDefault();
      this.closeSelector(true);
      return;
    }

    if (action.matches('[data-close-upload]')) {
      event.preventDefault();
      this.closeUploadDrawer(true);
      return;
    }

    if (action.matches('[data-open-email-delivery]')) {
      event.preventDefault();
      this.openEmailDelivery();
      return;
    }

    if (action.matches('[data-close-email-delivery]')) {
      event.preventDefault();
      this.closeEmailDelivery(true);
      return;
    }

    if (action.matches('[data-add-selected-to-cart]')) {
      event.preventDefault();
      this.addSelectedProductsToCart();
      return;
    }

    if (action.matches('[data-confirm-upload]')) {
      event.preventDefault();
      this.confirmUploadDrawer();
      return;
    }

    if (action.matches('[data-generation-history-item]')) {
      event.preventDefault();
      this.selectGenerationHistory(Number(action.dataset.generationHistoryIndex));
      return;
    }

    if (action.matches('[data-history-item]')) {
      event.preventDefault();
      this.selectHistory(Number(action.dataset.historyIndex));
      return;
    }

    if (action.matches('[data-generate]')) {
      event.preventDefault();
      this.startGeneration(true);
      return;
    }

    if (action.matches('[data-retry-generation]')) {
      event.preventDefault();
      this.startGeneration(action.dataset.retrySameRequest !== 'true');
      return;
    }

    if (action.matches('[data-retry-upload]')) {
      event.preventDefault();
      this.triggerUpload('album');
      return;
    }

  };

  AiSceneGenerator.prototype.onChange = function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-file-input]')) return;
    var file = input.files && input.files[0];
    input.value = '';
    if (!file) return;
    var closeUploadDrawerAfterSelection = this.overlayState === 'UPLOAD_DRAWER_OPEN';
    this.handleFile(file);
    if (closeUploadDrawerAfterSelection) this.closeUploadDrawer(true);
  };

  AiSceneGenerator.prototype.onSubmit = function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-email-delivery-form]')) return;
    event.preventDefault();
    this.submitEmailDelivery();
  };

  AiSceneGenerator.prototype.onKeydown = function (event) {
    var tab = event.target && event.target.closest ? event.target.closest('[role="tab"]') : null;
    var tabNavigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    if (tab && this.root.contains(tab) && tabNavigationKeys.indexOf(event.key) >= 0) {
      var tablist = tab.closest('[role="tablist"]');
      var tabs = tablist ? Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]:not([disabled])')) : [];
      var currentIndex = tabs.indexOf(tab);
      if (currentIndex >= 0 && tabs.length) {
        var nextIndex = currentIndex;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % tabs.length;
        event.preventDefault();
        tabs[nextIndex].focus();
        if (tabs[nextIndex].matches('[data-main-tab]')) this.switchMainTab(tabs[nextIndex].dataset.mainTab);
        if (tabs[nextIndex].matches('[data-selector-tab]')) this.switchSelectorTab(normalizeType(tabs[nextIndex].dataset.selectorTab));
      }
      return;
    }

    if (!this.overlayState) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      if (this.overlayState === 'PRODUCT_SELECTOR_OPEN') this.closeSelector(true);
      if (this.overlayState === 'UPLOAD_DRAWER_OPEN') this.closeUploadDrawer(true);
      if (this.overlayState === 'EMAIL_DELIVERY_OPEN') this.closeEmailDelivery(true);
      if (this.overlayState === 'DAILY_LIMIT_OPEN') this.closeDailyLimit(true);
      return;
    }
    if (event.key !== 'Tab') return;
    var dialog = this.nodes.uploadDialog;
    if (this.overlayState === 'PRODUCT_SELECTOR_OPEN') dialog = this.nodes.selectorDialog;
    if (this.overlayState === 'EMAIL_DELIVERY_OPEN') dialog = this.nodes.emailDeliveryDialog;
    if (this.overlayState === 'DAILY_LIMIT_OPEN') dialog = this.nodes.dailyLimitDialog;
    var focusable = focusableWithin(dialog);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (document.activeElement === dialog || !dialog.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  AiSceneGenerator.prototype.currentState = function () {
    return this.overlayState || this.baseState;
  };

  AiSceneGenerator.prototype.assertActive = function () {
    if (this.destroyed) throw new DOMException('The operation was aborted.', 'AbortError');
  };

  AiSceneGenerator.prototype.setBaseState = function (state) {
    if (this.destroyed) return;
    this.baseState = state;
    if (!this.overlayState) this.root.dataset.state = state;
    this.renderAll();
  };

  AiSceneGenerator.prototype.setOverlayState = function (state) {
    this.overlayState = state;
    this.root.dataset.state = state;
    this.renderAll();
  };

  AiSceneGenerator.prototype.clearOverlayState = function () {
    this.overlayState = '';
    this.root.dataset.state = this.baseState;
    this.renderAll();
  };

  AiSceneGenerator.prototype.renderAll = function () {
    if (this.destroyed) return;
    this.renderStage();
    this.renderProducts();
    this.renderCart();
    this.renderProcessingProducts();
    this.renderHistory();
    this.updateControls();
  };

  AiSceneGenerator.prototype.renderStage = function () {
    var hasPreview = Boolean(this.room.previewUrl);
    var hasExampleImage = Boolean(this.nodes.exampleImage);
    var isProcessing = this.baseState === 'PROCESSING';
    var isGenerating = this.generationPending || this.baseState === 'UPLOADING' || isProcessing;
    var showProcessingOverlay = Boolean(this.generationPending && isProcessing && hasPreview);
    var liveCartResult = Boolean(
      this.generation &&
      this.generation.origin === 'live' &&
      this.generation.sourceTab === 'cart'
    );
    var cartReconciliationPending = liveCartResult && (this.cartRefreshPending || this.cartRefreshDirty);
    var hasSucceededResult = this.baseState === 'SUCCEEDED' && Boolean(this.resultUrl);
    var isSucceeded = this.baseState === 'SUCCEEDED' && Boolean(this.resultUrl) && !cartReconciliationPending;
    setHidden(this.nodes.emptyState, hasPreview || hasExampleImage || isSucceeded);
    setHidden(this.nodes.exampleImage, hasPreview || isSucceeded);
    setHidden(this.nodes.roomImage, !hasPreview || isSucceeded);
    setHidden(this.nodes.resultImage, !isSucceeded);
    setHidden(this.nodes.resultDisclaimer, !isSucceeded);
    setHidden(this.nodes.stageChange, (!hasPreview && !isSucceeded) || isGenerating);
    setHidden(this.nodes.processingOverlay, !showProcessingOverlay);
    setHidden(this.nodes.stageStatus, this.baseState !== 'UPLOADING');
    setHidden(this.nodes.panelDefaultActions, hasSucceededResult);
    setHidden(this.nodes.panelResultActions, !isSucceeded);
    this.syncProcessingTipCarousel(showProcessingOverlay);
    this.syncProgressParticleField(showProcessingOverlay);

    if (this.nodes.roomImage && hasPreview && this.nodes.roomImage.src !== this.room.previewUrl) {
      this.nodes.roomImage.src = this.room.previewUrl;
      this.nodes.roomImage.alt = this.room.fileName || 'Room photo';
    }
    if (this.nodes.resultImage && isSucceeded && this.nodes.resultImage.src !== this.resultUrl) {
      this.nodes.resultImage.src = this.resultUrl;
      this.nodes.resultImage.alt = this.labels.success;
    }
    if (this.nodes.mobileDownload) {
      this.nodes.mobileDownload.disabled = !isSucceeded;
      this.nodes.mobileDownload.setAttribute('aria-disabled', isSucceeded ? 'false' : 'true');
    }

    this.renderGenerationProgress();
    if (this.nodes.stageStatus) {
      if (this.baseState === 'UPLOADING') this.nodes.stageStatus.textContent = 'Uploading…';
    }
    if (this.nodes.thumbnails) {
      setHidden(this.nodes.thumbnails, false);
      this.renderThumbnails();
    }
    if (this.nodes.error) {
      setHidden(this.nodes.error, !this.errorMessage);
    }
  };

  AiSceneGenerator.prototype.calculateGenerationProgress = function (now) {
    if (!this.generationProgressStartedAt) return 0;
    var elapsed = Math.max(0, Number(now) - this.generationProgressStartedAt);
    var duration = Math.max(1, this.generationProgressDurationMs);
    if (elapsed <= duration) {
      var estimatedRange = GENERATION_PROGRESS_ESTIMATED_PERCENT - GENERATION_PROGRESS_START_PERCENT;
      return GENERATION_PROGRESS_START_PERCENT + estimatedRange * (elapsed / duration);
    }
    var overtimeRatio = (elapsed - duration) / duration;
    var overtimeRange = GENERATION_PROGRESS_MAX_PERCENT - GENERATION_PROGRESS_ESTIMATED_PERCENT;
    return GENERATION_PROGRESS_ESTIMATED_PERCENT + overtimeRange * (1 - Math.exp(-overtimeRatio));
  };

  AiSceneGenerator.prototype.renderGenerationProgress = function () {
    var progress = Math.max(0, Math.min(100, Number(this.generationProgress) || 0));
    var roundedProgress = Math.round(progress);
    if (this.nodes.generationProgressFill) {
      this.nodes.generationProgressFill.style.width = progress.toFixed(4) + '%';
    }
    if (roundedProgress !== this.generationProgressRounded) {
      this.generationProgressRounded = roundedProgress;
      if (this.nodes.generationProgressValue) {
        this.nodes.generationProgressValue.textContent = roundedProgress + '%';
      }
      if (this.nodes.generationProgress) {
        this.nodes.generationProgress.setAttribute('aria-valuenow', String(roundedProgress));
        this.nodes.generationProgress.setAttribute('aria-valuetext', roundedProgress + '%');
      }
    }
  };

  AiSceneGenerator.prototype.setGenerationProgress = function (value, allowDecrease) {
    var progress = Number(value);
    if (!Number.isFinite(progress)) return;
    progress = Math.max(0, Math.min(100, progress));
    if (!allowDecrease) progress = Math.max(this.generationProgress, progress);
    this.generationProgress = progress;
    this.renderGenerationProgress();
  };

  AiSceneGenerator.prototype.startGenerationProgress = function () {
    this.stopGenerationProgress(true);
    this.generationProgressStartedAt = Date.now();
    this.setGenerationProgress(GENERATION_PROGRESS_START_PERCENT, true);
    if (this.nodes.generationProgressStatus) {
      this.nodes.generationProgressStatus.textContent = this.labels.processing;
    }
    var self = this;
    this.generationProgressInterval = window.setInterval(function () {
      if (self.destroyed || !self.generationPending) {
        self.stopGenerationProgress(false);
        return;
      }
      self.setGenerationProgress(self.calculateGenerationProgress(Date.now()));
    }, GENERATION_PROGRESS_UPDATE_INTERVAL_MS);
  };

  AiSceneGenerator.prototype.stopGenerationProgress = function (reset) {
    if (this.generationProgressInterval) {
      window.clearInterval(this.generationProgressInterval);
      this.generationProgressInterval = 0;
    }
    this.generationProgressStartedAt = 0;
    if (reset) this.setGenerationProgress(0, true);
  };

  AiSceneGenerator.prototype.syncProgressParticleField = function (active) {
    var particleLayer = this.nodes && this.nodes.progressParticles;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!active || reduceMotion || !particleLayer) {
      this.stopProgressParticleField();
      return;
    }
    if (this.progressParticleInterval) return;

    // Start with a small burst so the field feels alive immediately, then
    // continue spawning on a short cadence while the task is processing.
    this.spawnProgressParticles(PROGRESS_PARTICLE_INITIAL_BURST_COUNT);
    var self = this;
    this.progressParticleInterval = window.setInterval(function () {
      if (
        self.destroyed ||
        !self.generationPending ||
        self.baseState !== 'PROCESSING' ||
        !self.nodes.processingOverlay ||
        self.nodes.processingOverlay.hidden ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      ) {
        self.stopProgressParticleField();
        return;
      }
      self.spawnProgressParticles(1);
    }, PROGRESS_PARTICLE_SPAWN_INTERVAL_MS);
  };

  AiSceneGenerator.prototype.spawnProgressParticles = function (count) {
    var particleLayer = this.nodes && this.nodes.progressParticles;
    var progressNode = this.nodes && this.nodes.generationProgress;
    var stage = this.nodes && this.nodes.stage;
    if (!particleLayer || !progressNode || !stage) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var layerRect = particleLayer.getBoundingClientRect();
    var progressRect = progressNode.getBoundingClientRect();
    var layerWidth = layerRect.width;
    var layerHeight = layerRect.height;
    if (!(layerWidth > 0 && layerHeight > 0 && progressRect.width > 0 && progressRect.height > 0)) return;

    var progressRatio = Math.max(0, Math.min(1, (Number(this.generationProgress) || 0) / 100));
    var targetX = Math.max(0, Math.min(layerWidth, progressRect.left - layerRect.left + progressRect.width * progressRatio));
    var targetY = Math.max(0, Math.min(layerHeight, progressRect.top - layerRect.top + progressRect.height / 2));
    var viewportScale = Math.max(0.75, Math.min(1.5, layerWidth / 900));
    var amount = Math.max(1, Number(count) || 1);

    for (var index = 0; index < amount; index += 1) {
      // Keep the particles clearly visible while retaining natural size variation.
      var size = (3 + Math.random() * 6) * viewportScale;
      var side = Math.floor(Math.random() * 4);
      var startX;
      var startY;
      if (side === 0) {
        startX = Math.random() * layerWidth;
        startY = -size * (0.8 + Math.random() * 1.5);
      } else if (side === 1) {
        startX = layerWidth + size * (0.8 + Math.random() * 1.5);
        startY = Math.random() * layerHeight;
      } else if (side === 2) {
        startX = Math.random() * layerWidth;
        startY = layerHeight + size * (0.8 + Math.random() * 1.5);
      } else {
        startX = -size * (0.8 + Math.random() * 1.5);
        startY = Math.random() * layerHeight;
      }

      var duration = PROGRESS_PARTICLE_MIN_DURATION_MS + Math.random() * (
        PROGRESS_PARTICLE_MAX_DURATION_MS - PROGRESS_PARTICLE_MIN_DURATION_MS
      );
      var particle = document.createElement('span');
      particle.className = 'ai-scene-generator__progress-particle';
      particle.setAttribute('aria-hidden', 'true');
      particle.style.setProperty('--particle-size', size.toFixed(2) + 'px');
      // Translate the particle's top-left corner by half its size so its
      // visual center starts and finishes at the requested coordinates.
      particle.style.setProperty('--particle-start-x', (startX - size / 2).toFixed(2) + 'px');
      particle.style.setProperty('--particle-start-y', (startY - size / 2).toFixed(2) + 'px');
      particle.style.setProperty('--particle-end-x', (targetX - size / 2).toFixed(2) + 'px');
      particle.style.setProperty('--particle-end-y', (targetY - size / 2).toFixed(2) + 'px');
      particle.style.setProperty('--particle-duration', duration.toFixed(0) + 'ms');
      particle.style.setProperty('--particle-delay', (Math.random() * 80).toFixed(0) + 'ms');
      particle.dataset.particleId = String(++this.progressParticleSequence);
      particleLayer.appendChild(particle);

      var maxCount = PROGRESS_PARTICLE_MAX_COUNT;
      while (particleLayer.children.length > maxCount) {
        var oldestParticle = particleLayer.firstElementChild;
        if (!oldestParticle) break;
        if (typeof oldestParticle.__aiProgressParticleCleanup === 'function') {
          oldestParticle.__aiProgressParticleCleanup();
        } else {
          particleLayer.removeChild(oldestParticle);
        }
      }
      this.scheduleProgressParticleCleanup(particle, duration);
    }
  };

  AiSceneGenerator.prototype.scheduleProgressParticleCleanup = function (particle, duration) {
    if (!particle) return;
    var self = this;
    var timerId = 0;
    var removed = false;
    var cleanup = function () {
      if (removed) return;
      removed = true;
      particle.removeEventListener('animationend', cleanup);
      if (timerId) {
        window.clearTimeout(timerId);
        self.progressParticleCleanupTimers.delete(timerId);
      }
      if (particle.parentNode) particle.parentNode.removeChild(particle);
    };
    particle.__aiProgressParticleCleanup = cleanup;
    particle.addEventListener('animationend', cleanup, { once: true });
    timerId = window.setTimeout(cleanup, Math.max(0, Number(duration) || 0) + 500);
    this.progressParticleCleanupTimers.add(timerId);
  };

  AiSceneGenerator.prototype.stopProgressParticleField = function () {
    if (this.progressParticleInterval) {
      window.clearInterval(this.progressParticleInterval);
      this.progressParticleInterval = 0;
    }
    if (this.progressParticleCleanupTimers && this.progressParticleCleanupTimers.size) {
      this.progressParticleCleanupTimers.forEach(function (timerId) {
        window.clearTimeout(timerId);
      });
      this.progressParticleCleanupTimers.clear();
    }
    var particleLayer = this.nodes && this.nodes.progressParticles;
    if (particleLayer) particleLayer.replaceChildren();
  };

  AiSceneGenerator.prototype.syncProcessingTipCarousel = function (active) {
    if (!active || !this.nodes.processingTipText) {
      this.stopProcessingTipCarousel(true);
      return;
    }

    if (!this.processingTipInterval) {
      this.processingTipIndex = 0;
      this.nodes.processingTipText.textContent = this.processingTips[0] || DEFAULT_PROCESSING_TIP;
    }
    if (this.processingTips.length < 2 || this.processingTipInterval) return;

    var self = this;
    this.processingTipInterval = window.setInterval(function () {
      self.rotateProcessingTip();
    }, PROCESSING_TIP_ROTATION_DELAY_MS);
  };

  AiSceneGenerator.prototype.rotateProcessingTip = function () {
    var tipText = this.nodes.processingTipText;
    if (
      this.destroyed ||
      !this.generationPending ||
      !tipText ||
      this.processingTips.length < 2
    ) {
      this.stopProcessingTipCarousel(true);
      return;
    }
    if (this.processingTipSwapTimer || this.processingTipAnimationTimer) return;

    var nextIndex = (this.processingTipIndex + 1) % this.processingTips.length;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      this.processingTipIndex = nextIndex;
      tipText.textContent = this.processingTips[nextIndex];
      return;
    }

    var self = this;
    tipText.classList.add('is-leaving');
    this.processingTipSwapTimer = window.setTimeout(function () {
      self.processingTipSwapTimer = 0;
      if (self.destroyed || self.baseState !== 'PROCESSING') {
        self.stopProcessingTipCarousel(true);
        return;
      }
      self.processingTipIndex = nextIndex;
      tipText.textContent = self.processingTips[nextIndex];
      tipText.classList.remove('is-leaving');
      tipText.classList.add('is-entering');
      self.processingTipAnimationTimer = window.setTimeout(function () {
        self.processingTipAnimationTimer = 0;
        tipText.classList.remove('is-entering');
      }, PROCESSING_TIP_SLIDE_DURATION_MS);
    }, PROCESSING_TIP_SLIDE_DURATION_MS);
  };

  AiSceneGenerator.prototype.stopProcessingTipCarousel = function (reset) {
    if (this.processingTipInterval) {
      window.clearInterval(this.processingTipInterval);
      this.processingTipInterval = 0;
    }
    if (this.processingTipSwapTimer) {
      window.clearTimeout(this.processingTipSwapTimer);
      this.processingTipSwapTimer = 0;
    }
    if (this.processingTipAnimationTimer) {
      window.clearTimeout(this.processingTipAnimationTimer);
      this.processingTipAnimationTimer = 0;
    }
    if (!this.nodes || !this.nodes.processingTipText) return;
    this.nodes.processingTipText.classList.remove('is-leaving', 'is-entering');
    if (!reset) return;
    this.processingTipIndex = 0;
    this.nodes.processingTipText.textContent = this.processingTips[0] || DEFAULT_PROCESSING_TIP;
  };

  AiSceneGenerator.prototype.renderThumbnails = function () {
    var list = this.nodes.thumbnails;
    if (!list) return;
    var focusedTaskId = '';
    var focusedElement = document.activeElement;
    var focusedHistoryButton = focusedElement && focusedElement.closest
      ? focusedElement.closest('[data-generation-history-item]')
      : null;
    if (focusedHistoryButton && list.contains(focusedHistoryButton)) {
      focusedTaskId = String(focusedHistoryButton.dataset.generationTaskId || '').trim();
    }
    list.querySelectorAll('[data-generation-history-item]').forEach(function (button) {
      button.remove();
    });
    var activeTaskId = this.baseState === 'SUCCEEDED'
      ? String(this.generation && this.generation.taskId || '').trim()
      : '';
    var renderedCount = 0;
    var focusTarget = null;
    this.generationHistory.forEach(function (item, index) {
      if (!item || item.status !== 'SUCCEEDED' || !item.resultImageUrl) return;
      var productNames = Array.isArray(item.products) ? item.products.map(function (product) {
        return String(product && product.name || '').trim();
      }).filter(Boolean) : [];
      var label = productNames.length ? productNames.join(', ') : this.labels.success;
      var historyButton = createElement('button', 'ai-scene-generator__thumbnail');
      historyButton.type = 'button';
      historyButton.dataset.generationHistoryIndex = String(index);
      historyButton.dataset.generationHistoryItem = 'true';
      historyButton.dataset.generationTaskId = String(item.taskId || '').trim();
      if (focusedTaskId && historyButton.dataset.generationTaskId === focusedTaskId) focusTarget = historyButton;
      historyButton.classList.toggle('is-active', Boolean(activeTaskId && activeTaskId === item.taskId));
      historyButton.setAttribute('aria-label', label);
      historyButton.setAttribute('aria-pressed', activeTaskId === item.taskId ? 'true' : 'false');
      var historyImage = createElement('img');
      historyImage.src = item.resultImageUrl;
      historyImage.alt = label;
      historyImage.loading = 'lazy';
      historyImage.draggable = false;
      historyImage.dataset.generatedImage = 'true';
      historyButton.appendChild(historyImage);
      list.appendChild(historyButton);
      renderedCount += 1;
    }, this);
    list.classList.toggle('has-generation-thumbnails', renderedCount > 0);
    if (focusTarget) {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (error) {
        focusTarget.focus();
      }
    }
  };

  AiSceneGenerator.prototype.normalizeGenerationHistoryItem = function (value) {
    var item = value && typeof value === 'object' ? value : {};
    var taskId = String(item.taskId || '').trim();
    var status = String(item.status || '').trim().toUpperCase();
    var resultImageUrl = normalizeHttpsUrl(item.resultImageUrl);
    if (!taskId || status !== 'SUCCEEDED' || !resultImageUrl) return null;
    var seenProducts = new Set();
    var products = Array.isArray(item.products) ? item.products.map(function (product) {
      var source = product && typeof product === 'object' ? product : {};
      var type = normalizeType(source.type);
      var name = String(source.name || '').trim().slice(0, 256);
      var key = type + '\u0000' + name;
      if (!type || !name || seenProducts.has(key)) return null;
      seenProducts.add(key);
      return { type: type, name: name };
    }).filter(Boolean) : [];
    var createdAt = String(item.createdAt || '').trim();
    if (!Number.isFinite(Date.parse(createdAt))) createdAt = '';
    var hasDuration = item.durationMs !== null && typeof item.durationMs !== 'undefined' && item.durationMs !== '';
    var durationMs = hasDuration ? Number(item.durationMs) : NaN;
    return {
      taskId: taskId,
      status: 'SUCCEEDED',
      createdAt: createdAt,
      productCombination: String(item.productCombination || '').trim(),
      products: products,
      resultImageUrl: resultImageUrl,
      durationMs: Number.isFinite(durationMs) && durationMs >= 0 ? durationMs : null,
      sourceTab: 'history',
      selectedProducts: [],
      payload: null,
      idempotencyKey: '',
      location: ''
    };
  };

  AiSceneGenerator.prototype.mergeGenerationHistory = function (items) {
    var byTaskId = new Map();
    var mergeItem = function (incoming) {
      if (!incoming || !incoming.taskId) return;
      var previous = byTaskId.get(incoming.taskId);
      if (!previous) {
        byTaskId.set(incoming.taskId, incoming);
        return;
      }
      var previousCanRestoreCommerce = (
        (previous.sourceTab === 'room' || previous.sourceTab === 'cart') &&
        Array.isArray(previous.selectedProducts) &&
        previous.selectedProducts.length > 0
      );
      var incomingCanRestoreCommerce = (
        (incoming.sourceTab === 'room' || incoming.sourceTab === 'cart') &&
        Array.isArray(incoming.selectedProducts) &&
        incoming.selectedProducts.length > 0
      );
      var commerceSource = incomingCanRestoreCommerce
        ? incoming
        : (previousCanRestoreCommerce ? previous : null);
      var merged = Object.assign({}, previous, incoming);
      merged.products = incoming.products && incoming.products.length ? incoming.products : previous.products;
      merged.createdAt = incoming.createdAt || previous.createdAt;
      if (commerceSource) {
        merged.sourceTab = commerceSource.sourceTab;
        merged.selectedProducts = commerceSource.selectedProducts;
        merged.payload = commerceSource.payload;
        merged.idempotencyKey = commerceSource.idempotencyKey || '';
        merged.location = commerceSource.location || '';
      } else {
        merged.sourceTab = 'history';
        merged.selectedProducts = [];
        merged.payload = null;
        merged.idempotencyKey = '';
        merged.location = '';
      }
      byTaskId.set(incoming.taskId, merged);
    };
    this.generationHistory.forEach(mergeItem);
    (Array.isArray(items) ? items : []).forEach(mergeItem);
    this.generationHistory = Array.from(byTaskId.values()).sort(function (left, right) {
      var leftTime = Date.parse(left.createdAt || '') || 0;
      var rightTime = Date.parse(right.createdAt || '') || 0;
      if (leftTime !== rightTime) return rightTime - leftTime;
      return String(right.taskId).localeCompare(String(left.taskId));
    });
  };

  AiSceneGenerator.prototype.fetchGenerationHistory = async function (tokenRetried) {
    this.assertActive();
    if (!this.visitorToken) {
      await this.ensureUploadAuthorization();
      this.assertActive();
    }
    var requestVisitorToken = String(this.visitorToken || '');
    var headers = await this.buildHeaders({});
    this.assertActive();
    var historyUrl = this.resolveApiRequestUrl(this.endpoint('generations'));
    historyUrl.searchParams.set('status', 'SUCCEEDED');
    historyUrl.searchParams.set('pageSize', '20');
    try {
      var result = await this.request('', {
        method: 'GET',
        url: historyUrl.href,
        headers: headers
      });
      this.assertActive();
      var data = result.data && typeof result.data === 'object' ? result.data : {};
      var items = Array.isArray(data.items) ? data.items.map(function (item) {
        return this.normalizeGenerationHistoryItem(item);
      }, this).filter(Boolean) : [];
      var nextCursor = String(data.nextCursor || '').trim();
      return {
        items: items,
        nextCursor: nextCursor,
        hasMore: data.hasMore === true && Boolean(nextCursor)
      };
    } catch (error) {
      if (!tokenRetried && error && (error.code === 'VISITOR_TOKEN_INVALID' || error.code === 'VISITOR_TOKEN_REQUIRED')) {
        await this.recoverVisitorAuthorization(requestVisitorToken);
        return this.fetchGenerationHistory(true);
      }
      throw error;
    }
  };

  AiSceneGenerator.prototype.loadGenerationHistory = function () {
    if (this.generationHistoryLoadPromise || this.destroyed) return this.generationHistoryLoadPromise;
    var self = this;
    var operation = this.fetchGenerationHistory(false).then(function (history) {
      self.mergeGenerationHistory(history.items);
      self.generationHistoryNextCursor = history.nextCursor;
      self.generationHistoryHasMore = history.hasMore;
      if (!self.destroyed) self.renderAll();
      return history.items;
    }).catch(function (error) {
      if (isAbortError(error) || self.destroyed) return [];
      // History is supplementary: authorization or network failures must not
      // block room selection, upload, generation, or the current result.
      return [];
    });
    var loadPromise;
    loadPromise = operation.then(function (items) {
      if (self.generationHistoryLoadPromise === loadPromise) self.generationHistoryLoadPromise = null;
      return items;
    }, function (error) {
      if (self.generationHistoryLoadPromise === loadPromise) self.generationHistoryLoadPromise = null;
      throw error;
    });
    this.generationHistoryLoadPromise = loadPromise;
    return loadPromise;
  };

  AiSceneGenerator.prototype.recordSuccessfulGeneration = function (data, resultImageUrl) {
    var generation = this.generation || {};
    var payloadProducts = generation.payload && Array.isArray(generation.payload.products)
      ? generation.payload.products
      : [];
    var item = this.normalizeGenerationHistoryItem({
      taskId: generation.taskId || data.taskId,
      status: 'SUCCEEDED',
      createdAt: data.createdAt || new Date().toISOString(),
      productCombination: data.productCombination,
      products: payloadProducts,
      resultImageUrl: resultImageUrl,
      durationMs: data.durationMs
    });
    if (!item) return;
    item.sourceTab = generation.sourceTab === 'room' || generation.sourceTab === 'cart'
      ? generation.sourceTab
      : 'history';
    item.selectedProducts = Array.isArray(generation.selectedProducts)
      ? generation.selectedProducts.map(function (product) { return Object.assign({}, product); })
      : [];
    item.payload = generation.payload && typeof generation.payload === 'object'
      ? Object.assign({}, generation.payload, {
        roomImages: Array.isArray(generation.payload.roomImages)
          ? generation.payload.roomImages.map(function (roomImage) { return Object.assign({}, roomImage); })
          : [],
        products: payloadProducts.map(function (product) { return Object.assign({}, product); })
      })
      : null;
    item.idempotencyKey = String(generation.idempotencyKey || '');
    item.location = String(generation.location || '');
    this.mergeGenerationHistory([item]);
  };

  AiSceneGenerator.prototype.renderProducts = function () {
    var self = this;
    this.root.querySelectorAll('[data-product-group]').forEach(function (group) {
      var type = normalizeType(group.dataset.type);
      var row = group.querySelector('[data-open-selector]');
      var imageContainer = group.querySelector('[data-panel-image]');
      var name = group.querySelector('[data-panel-name]');
      var title = group.querySelector('[data-panel-title]');
      var variantAttribute = group.querySelector('[data-panel-sku]');
      var selected = self.selected.get(type);
      if (!row || !imageContainer || !name) return;
      row.classList.toggle('is-selected', Boolean(selected));
      row.setAttribute('aria-expanded', self.overlayState === 'PRODUCT_SELECTOR_OPEN' && self.selectorType === type ? 'true' : 'false');
      var selectedTitle = selected ? String(selected.title || selected.name || '').trim() : '';
      var selectedVariantTitle = selected ? String(selected.variantTitle || '').trim() : '';
      var selectedLabel = selectedTitle + (selectedVariantTitle ? ', ' + selectedVariantTitle : '');
      row.setAttribute('aria-label', selected ? selectedLabel : self.labels.selectProduct);
      imageContainer.replaceChildren();
      if (selected && selected.imageUrl) {
        var image = createElement('img');
        image.src = selected.imageUrl;
        image.alt = selected.name;
        image.loading = 'lazy';
        imageContainer.appendChild(image);
      } else {
        imageContainer.appendChild(createElement('span', 'ai-scene-generator__product-placeholder', '＋'));
      }
      if (title && variantAttribute) {
        title.textContent = selected ? selectedTitle : self.labels.selectProduct;
        variantAttribute.textContent = selectedVariantTitle;
        variantAttribute.hidden = !selectedVariantTitle;
      } else {
        name.textContent = selected ? selectedTitle : self.labels.selectProduct;
      }
    });

    this.root.querySelectorAll('[data-product-tile]').forEach(function (tile) {
      var optionKey = tile.dataset.productOptionKey || tile.dataset.blockId || '';
      var type = normalizeType(tile.dataset.productType);
      var selected = self.draftSelections.get(type);
      tile.setAttribute('aria-pressed', selected && selected.optionKey === optionKey ? 'true' : 'false');
    });

    if (this.nodes.productRequirement) {
      var showRequirement = this.mainTab === 'room' && this.hasRoomSource() && this.getActiveGenerationProducts().length === 0 && this.baseState !== 'PROCESSING';
      this.nodes.productRequirement.hidden = !showRequirement;
      this.nodes.productRequirement.textContent = this.labels.noProduct;
    }
  };

  AiSceneGenerator.prototype.renderCart = function () {
    if (!this.nodes.cartList || !this.nodes.cartEmpty) return;
    var self = this;
    var cartProducts = this.cartProducts;
    var availableProducts = this.getAvailableCartProducts(cartProducts);
    var focusedItem = document.activeElement && document.activeElement.closest
      ? document.activeElement.closest('[data-cart-product]')
      : null;
    var focusedOptionKey = focusedItem && this.nodes.cartList.contains(focusedItem)
      ? String(focusedItem.dataset.productOptionKey || '')
      : '';
    var focusTarget = null;
    if (this.nodes.cartStatus) {
      this.nodes.cartStatus.replaceChildren();
      if (this.cartRefreshPending) {
        this.nodes.cartStatus.appendChild(createElement('span', '', this.labels.cartRefreshing));
        this.nodes.cartStatus.hidden = false;
      } else if (this.cartRefreshDirty) {
        this.nodes.cartStatus.appendChild(createElement('span', '', this.labels.cartRefreshFailed));
        var retryButton = createElement('button', 'ai-scene-generator__cart-retry', this.labels.cartRetry);
        retryButton.type = 'button';
        retryButton.dataset.refreshCart = 'true';
        this.nodes.cartStatus.appendChild(retryButton);
        this.nodes.cartStatus.hidden = false;
      } else {
        this.nodes.cartStatus.hidden = true;
      }
    }

    this.nodes.cartList.replaceChildren();
    this.nodes.cartEmpty.replaceChildren();
    this.nodes.cartEmpty.hidden = availableProducts.length > 0;
    if (!availableProducts.length) {
      var emptyMessage = cartProducts.length ? this.labels.cartUnavailable : this.labels.cartEmpty;
      this.nodes.cartEmpty.appendChild(createElement('span', 'ai-scene-generator__cart-empty-message', emptyMessage));
      var switchButton = createElement('button', 'ai-scene-generator__cart-switch', this.labels.roomProduct);
      switchButton.type = 'button';
      switchButton.dataset.switchMainTab = 'room';
      this.nodes.cartEmpty.appendChild(switchButton);
    }
    cartProducts.forEach(function (product) {
      var selected = self.cartSelections.get(product.type);
      var isSelected = Boolean(selected && selected.optionKey === product.optionKey);
      var interactionDisabled = self.generationPending ||
        self.baseState === 'PROCESSING' ||
        self.baseState === 'UPLOADING' ||
        self.cartRefreshPending ||
        self.cartRefreshDirty;
      var item = createElement('button', 'ai-scene-generator__cart-item');
      item.type = 'button';
      item.dataset.cartProduct = 'true';
      item.dataset.productOptionKey = product.optionKey;
      item.dataset.productType = product.type || '';
      item.disabled = !product.available || interactionDisabled;
      item.setAttribute('aria-disabled', item.disabled ? 'true' : 'false');
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      item.classList.toggle('is-selected', isSelected);
      item.classList.toggle('is-unavailable', !product.available);
      var media = createElement('div', 'ai-scene-generator__cart-item-image');
      if (product.imageUrl) {
        var image = createElement('img');
        image.src = product.imageUrl;
        image.alt = '';
        image.loading = 'lazy';
        media.appendChild(image);
      } else {
        media.appendChild(createElement('span', 'ai-scene-generator__product-placeholder', '＋'));
      }
      var content = createElement('div', 'ai-scene-generator__cart-item-content');
      var itemName = createElement('span', 'ai-scene-generator__cart-item-name', product.productTitle || product.name);
      var itemVariant = String(product.variantTitle || '').trim()
        ? createElement('span', 'ai-scene-generator__cart-item-variant', String(product.variantTitle).trim())
        : null;
      var accessibleLabel = String(product.productTitle || product.name || '').trim();
      if (itemVariant) accessibleLabel += ', ' + String(product.variantTitle).trim();
      if (!product.available) accessibleLabel += ', ' + self.labels.cartItemUnavailable;
      item.setAttribute('aria-label', accessibleLabel);
      item.title = accessibleLabel;
      content.appendChild(itemName);
      if (itemVariant) content.appendChild(itemVariant);
      var check = createElement('span', 'ai-scene-generator__cart-item-check');
      check.setAttribute('aria-hidden', 'true');
      if (self.nodes.selectedIconTemplate && self.nodes.selectedIconTemplate.content) {
        check.appendChild(self.nodes.selectedIconTemplate.content.cloneNode(true));
      }
      item.appendChild(media);
      item.appendChild(content);
      item.appendChild(check);
      self.nodes.cartList.appendChild(item);
      if (focusedOptionKey && focusedOptionKey === product.optionKey && !item.disabled) focusTarget = item;
    });
    if (focusTarget) {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (error) {
        focusTarget.focus();
      }
    }
  };

  AiSceneGenerator.prototype.toggleCartProduct = function (item) {
    if (
      this.mainTab !== 'cart' ||
      this.generationPending ||
      this.baseState === 'PROCESSING' ||
      this.baseState === 'UPLOADING' ||
      this.cartRefreshPending ||
      this.cartRefreshDirty ||
      item.disabled
    ) return;
    var type = normalizeType(item.dataset.productType);
    var optionKey = String(item.dataset.productOptionKey || '');
    var product = this.cartProducts.find(function (candidate) {
      return candidate && candidate.available && candidate.type === type && candidate.optionKey === optionKey;
    });
    if (!product) return;
    var current = this.cartSelections.get(type);
    if (current && current.optionKey === product.optionKey) this.cartSelections.delete(type);
    else this.cartSelections.set(type, Object.assign({}, product));
    this.resultUrl = '';
    this.generation = null;
    this.resetResultActionState();
    this.clearError();
    this.setBaseState(this.hasRoomSource() ? 'READY' : 'EMPTY');
  };

  AiSceneGenerator.prototype.getAvailableCartProducts = function (sourceProducts) {
    var products = Array.isArray(sourceProducts) ? sourceProducts : this.cartProducts;
    return products.filter(function (product) {
      return Boolean(product && product.available && product.type && product.imageUrl);
    });
  };

  AiSceneGenerator.prototype.getRoomGenerationProducts = function () {
    var products = [];
    var self = this;
    TYPE_ORDER.forEach(function (type) {
      var selected = self.selected.get(type);
      if (!selected || !selected.available || !selected.imageUrl) return;
      products.push({
        optionKey: selected.optionKey,
        type: type,
        name: String(selected.name || '').slice(0, 256),
        title: selected.title || selected.name,
        variantTitle: selected.variantTitle,
        imageUrl: selected.imageUrl,
        spinImageUrls: normalizeSpinImageUrls(selected.spinImageUrls),
        productUrl: selected.productUrl,
        variantId: selected.variantId,
        purchasable: selected.purchasable,
        preorderInfo: selected.preorderInfo
      });
    });
    return products;
  };

  AiSceneGenerator.prototype.getCartGenerationProducts = function () {
    var generationProducts = [];
    var self = this;
    TYPE_ORDER.forEach(function (type) {
      var product = self.cartSelections.get(type);
      if (!product || !product.available || !product.imageUrl) return;
      generationProducts.push({
        optionKey: product.optionKey,
        lineKey: product.lineKey,
        type: product.type,
        name: String(product.name || '').slice(0, 256),
        title: product.productTitle || product.name,
        variantTitle: product.variantTitle,
        imageUrl: product.imageUrl,
        spinImageUrls: normalizeSpinImageUrls(product.spinImageUrls),
        productUrl: product.productUrl,
        variantId: product.variantId,
        purchasable: product.purchasable,
        preorderInfo: product.preorderInfo
      });
    });
    return generationProducts;
  };

  AiSceneGenerator.prototype.cartProductSnapshotSignature = function (products) {
    return JSON.stringify(this.getAvailableCartProducts(products).map(function (product) {
      return {
        optionKey: String(product && product.optionKey || ''),
        type: normalizeType(product && product.type),
        name: String(product && product.name || '').slice(0, 256),
        imageUrl: normalizeHttpsUrl(product && product.imageUrl),
        spinImageUrls: normalizeSpinImageUrls(product && product.spinImageUrls),
        productUrl: normalizeStorefrontProductUrl(product && product.productUrl, this.shopUrl),
        variantId: String(product && product.variantId || '')
      };
    }, this));
  };

  AiSceneGenerator.prototype.cartGenerationSignature = function () {
    return JSON.stringify(this.getCartGenerationProducts().map(function (product) {
      return {
        type: normalizeType(product && product.type),
        name: String(product && product.name || '').slice(0, 256),
        imageUrl: normalizeHttpsUrl(product && product.imageUrl),
        spinImageUrls: normalizeSpinImageUrls(product && product.spinImageUrls),
        productUrl: normalizeStorefrontProductUrl(product && product.productUrl, this.shopUrl)
      };
    }, this));
  };

  AiSceneGenerator.prototype.reconcileCartSelections = function (products) {
    var nextProducts = Array.isArray(products) ? products : [];
    var nextSelections = new Map();
    TYPE_ORDER.forEach(function (type) {
      var selected = this.cartSelections.get(type);
      if (!selected) return;
      var match = nextProducts.find(function (product) {
        return product && product.available && product.type === type && product.optionKey === selected.optionKey;
      });
      if (!match && selected.variantId) {
        var variantMatches = nextProducts.filter(function (product) {
          return product && product.available && product.type === type && product.variantId === selected.variantId;
        });
        if (variantMatches.length === 1) match = variantMatches[0];
      }
      if (match) nextSelections.set(type, Object.assign({}, match));
    }, this);
    this.cartSelections = nextSelections;
  };

  AiSceneGenerator.prototype.generationProductSignature = function () {
    var generation = this.generation || {};
    var products = Array.isArray(generation.selectedProducts) && generation.selectedProducts.length
      ? generation.selectedProducts
      : (generation.payload && generation.payload.products);
    if (!Array.isArray(products)) return '';
    return JSON.stringify(products.map(function (product) {
      return {
        type: normalizeType(product && product.type),
        name: String(product && product.name || '').slice(0, 256),
        imageUrl: normalizeHttpsUrl(product && product.imageUrl),
        spinImageUrls: normalizeSpinImageUrls(product && product.spinImageUrls),
        productUrl: normalizeStorefrontProductUrl(product && product.productUrl, this.shopUrl)
      };
    }, this));
  };

  AiSceneGenerator.prototype.setCartProducts = function (products) {
    var nextProducts = Array.isArray(products) ? products : [];
    var currentSnapshotSignature = this.cartProductSnapshotSignature(this.cartProducts);
    var nextSnapshotSignature = this.cartProductSnapshotSignature(nextProducts);
    var changed = currentSnapshotSignature !== nextSnapshotSignature;
    if (this.generationPending || this.baseState === 'PROCESSING') {
      this.deferredCartProducts = nextProducts;
      return changed;
    }

    this.cartProducts = nextProducts;
    this.reconcileCartSelections(nextProducts);
    var selectedSignature = this.cartGenerationSignature();
    var resultSignature = this.generationProductSignature();
    var liveCartResult = Boolean(
      this.generation &&
      this.generation.origin === 'live' &&
      this.generation.sourceTab === 'cart'
    );
    if (liveCartResult && this.resultUrl && selectedSignature !== resultSignature) {
      this.resultUrl = '';
      this.generation = null;
      this.resetResultActionState();
      this.clearError();
      this.setBaseState(this.hasRoomSource() ? 'READY' : 'EMPTY');
    }
    return changed;
  };

  AiSceneGenerator.prototype.commitDeferredCartProducts = function () {
    if (!Array.isArray(this.deferredCartProducts)) return false;
    var products = this.deferredCartProducts;
    this.deferredCartProducts = null;
    return this.setCartProducts(products);
  };

  AiSceneGenerator.prototype.getActiveGenerationProducts = function () {
    return this.mainTab === 'cart' ? this.getCartGenerationProducts() : this.getRoomGenerationProducts();
  };

  AiSceneGenerator.prototype.getPayloadGenerationProducts = function () {
    var source = this.pendingGenerationProducts || this.getActiveGenerationProducts();
    return source.reduce(function (products, product) {
      return products.concat(buildGenerationProductEntries(product));
    }, []);
  };

  AiSceneGenerator.prototype.renderProcessingProducts = function () {
    if (!this.nodes.processingProducts) return;
    this.nodes.processingProducts.replaceChildren();
    var self = this;
    var generationProducts = this.generation && Array.isArray(this.generation.selectedProducts)
      ? this.generation.selectedProducts
      : [];
    var products = generationProducts.length
      ? generationProducts
      : (this.pendingGenerationProducts || this.getActiveGenerationProducts());
    var visibleProducts = products.length > 4 ? products.slice(0, 3) : products;
    visibleProducts.forEach(function (product) {
      var wrapper = createElement('span', 'ai-scene-generator__processing-product');
      var image = createElement('img');
      image.src = product.imageUrl;
      image.alt = product.name;
      image.loading = 'lazy';
      wrapper.appendChild(image);
      self.nodes.processingProducts.appendChild(wrapper);
    });
    if (products.length > 4) {
      this.nodes.processingProducts.appendChild(createElement(
        'span',
        'ai-scene-generator__processing-product ai-scene-generator__processing-product--more',
        '+' + String(products.length - visibleProducts.length)
      ));
    }
  };

  AiSceneGenerator.prototype.renderHistory = function () {
    var list = this.nodes.historyList;
    if (!list) return;
    var empty = this.nodes.historyEmpty;
    if (empty) empty.hidden = this.uploadHistory.length > 0;
    list.querySelectorAll('[data-history-item]').forEach(function (node) { node.remove(); });
    this.uploadHistory.forEach(function (item, index) {
      if (!item || !item.previewUrl) return;
      var button = createElement('button', 'ai-scene-generator__history-item');
      button.type = 'button';
      button.dataset.historyItem = 'true';
      button.dataset.historyIndex = String(index);
      button.classList.toggle('is-selected', this.pendingHistory === item || this.room.previewUrl === item.previewUrl);
      var image = createElement('img');
      image.src = item.previewUrl;
      image.alt = item.fileName || 'Previous room photo';
      image.loading = 'lazy';
      var label = createElement('span', 'ai-scene-generator__history-item-label', item.fileName || 'Room photo');
      button.appendChild(image);
      button.appendChild(label);
      list.appendChild(button);
    }, this);
  };

  AiSceneGenerator.prototype.hasUploadedRoom = function () {
    return Boolean(this.room.objectKey && this.room.uploadSessionId);
  };

  AiSceneGenerator.prototype.hasRoomSource = function () {
    return Boolean(this.room.file) || this.hasUploadedRoom();
  };

  AiSceneGenerator.prototype.updateControls = function () {
    var canGenerate = this.canGenerate();
    var uploadBusy = this.generationPending || this.baseState === 'UPLOADING' || this.baseState === 'PROCESSING';
    var busy = uploadBusy || (this.mainTab === 'cart' && this.cartRefreshPending);
    var taskId = String(this.generation && this.generation.taskId || '').trim();
    var resultReady = this.baseState === 'SUCCEEDED' && Boolean(this.resultUrl && taskId);
    var productResult = resultReady && this.generation && (
      this.generation.sourceTab === 'room' || this.generation.sourceTab === 'cart'
    );
    this.root.querySelectorAll('[data-generate]').forEach(function (button) {
      button.disabled = !canGenerate || busy;
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
    });
    if (this.nodes.confirmUpload) {
      this.nodes.confirmUpload.disabled = this.generationPending || !this.hasRoomSource() || this.baseState === 'UPLOADING' || this.baseState === 'PROCESSING';
    }
    if (this.nodes.thumbnailUpload) {
      this.nodes.thumbnailUpload.disabled = uploadBusy;
      this.nodes.thumbnailUpload.setAttribute('aria-disabled', uploadBusy ? 'true' : 'false');
    }
    this.root.querySelectorAll('[data-open-email-delivery]').forEach(function (button) {
      button.disabled = !resultReady || this.emailDeliveryPending;
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
    }, this);
    if (this.nodes.emailDeliverySubmit) {
      this.nodes.emailDeliverySubmit.disabled = this.emailDeliveryPending;
      this.nodes.emailDeliverySubmit.setAttribute('aria-busy', this.emailDeliveryPending ? 'true' : 'false');
    }
    var cartItems = productResult ? this.buildResultCartItems() : { items: [], complete: false };
    var cartActionDisabled = !productResult || !cartItems.complete || !cartItems.items.length || this.cartAddPending;
    this.nodes.addSelectedToCartButtons.forEach(function (button) {
      button.hidden = button.hasAttribute('data-mobile-add-to-cart') ? false : !productResult;
      button.disabled = cartActionDisabled;
      button.classList.toggle('is_loading', this.cartAddPending);
      button.setAttribute('aria-disabled', cartActionDisabled ? 'true' : 'false');
      button.setAttribute('aria-busy', this.cartAddPending ? 'true' : 'false');
    }, this);
    if (this.nodes.panelResultActions) {
      this.nodes.panelResultActions.classList.toggle('is-download-only', resultReady && !productResult);
    }
    if (this.nodes.panelStatus) {
      if (resultReady) this.nodes.panelStatus.textContent = '';
      else if (this.baseState === 'PROCESSING') this.nodes.panelStatus.textContent = this.labels.processing;
      else if (this.baseState === 'UPLOADING') this.nodes.panelStatus.textContent = 'Uploading…';
      else if (!this.hasRoomSource()) this.nodes.panelStatus.textContent = this.labels.upload;
      else if (!this.getActiveGenerationProducts().length) {
        if (this.mainTab !== 'cart' || this.getAvailableCartProducts().length) {
          this.nodes.panelStatus.textContent = this.labels.noProduct;
        } else {
          this.nodes.panelStatus.textContent = this.cartProducts.length ? this.labels.cartUnavailable : this.labels.cartEmpty;
        }
      }
      else this.nodes.panelStatus.textContent = '';
    }
  };

  AiSceneGenerator.prototype.canGenerate = function () {
    var identityReady = this.room.identityGeneration === currentIdentityGeneration() || Boolean(this.room.file);
    var cartReady = this.mainTab !== 'cart' || (!this.cartRefreshPending && !this.cartRefreshDirty);
    return this.hasRoomSource() && this.getActiveGenerationProducts().length > 0 && identityReady && cartReady && !this.generationPending && this.baseState !== 'UPLOADING' && this.baseState !== 'PROCESSING';
  };

  AiSceneGenerator.prototype.triggerUpload = function (kind) {
    if (this.generationPending || this.baseState === 'PROCESSING' || this.baseState === 'UPLOADING') return;
    var input = this.fileInputs[kind] || this.fileInputs.album;
    if (input) input.click();
  };

  AiSceneGenerator.prototype.validateFile = function (file, constraints) {
    var extension = String(file.name || '').split('.').pop().toLowerCase();
    var allowed = constraints && Array.isArray(constraints.allowedFormats) && constraints.allowedFormats.length
      ? constraints.allowedFormats.map(function (format) { return String(format).toLowerCase().replace(/^\./, ''); })
      : DEFAULT_ALLOWED_FORMATS;
    var maxSize = constraints && Number(constraints.maxSizeBytes) > 0 ? Number(constraints.maxSizeBytes) : DEFAULT_MAX_SIZE;
    if (allowed.indexOf(extension) < 0) {
      return { ok: false, message: 'This image format is not supported.' };
    }
    if (file.size > maxSize) {
      return { ok: false, message: 'This image is larger than the allowed limit.' };
    }
    return { ok: true, extension: extension };
  };

  AiSceneGenerator.prototype.handleFile = function (file) {
    if (this.destroyed || this.generationPending || this.baseState === 'PROCESSING' || this.baseState === 'UPLOADING') return;
    this.clearError();
    var validation = this.validateFile(file);
    if (!validation.ok) {
      this.showError(validation.message, 'upload');
      this.setUploadStatus(validation.message);
      if (!this.hasRoomSource()) this.setBaseState('FAILED');
      else this.renderAll();
      return;
    }

    this.identityGeneration = currentIdentityGeneration();
    this.uploadRequestId += 1;
    this.pendingHistory = null;
    if (this.room.previewUrl) this.addHistory(this.room);
    this.releasePreview(this.room.previewUrl, false);
    this.resultUrl = '';
    this.generation = null;
    this.resetResultActionState();
    this.room = {
      previewUrl: URL.createObjectURL(file),
      objectKey: '',
      uploadSessionId: '',
      identityGeneration: this.identityGeneration,
      fileName: file.name || '',
      file: file
    };
    this.setBaseState('READY');
    this.setUploadStatus('Photo selected.');
  };

  AiSceneGenerator.prototype.addHistory = function (room, protectedPreviewUrl) {
    if (!room || !room.previewUrl || (!room.file && !(room.objectKey && room.uploadSessionId))) return;
    var exists = this.uploadHistory.some(function (item) {
      return item.previewUrl === room.previewUrl || (
        room.objectKey &&
        room.uploadSessionId &&
        item.objectKey === room.objectKey &&
        item.uploadSessionId === room.uploadSessionId
      );
    });
    if (exists) return;
    this.uploadHistory.unshift({
      previewUrl: room.previewUrl,
      objectKey: room.objectKey,
      uploadSessionId: room.uploadSessionId,
      identityGeneration: room.identityGeneration,
      fileName: room.fileName || 'Room photo',
      file: room.file || null
    });
    if (this.uploadHistory.length > 6) {
      var removeIndex = this.uploadHistory.length - 1;
      if (
        protectedPreviewUrl &&
        this.uploadHistory[removeIndex] &&
        this.uploadHistory[removeIndex].previewUrl === protectedPreviewUrl
      ) {
        removeIndex -= 1;
      }
      var removed = this.uploadHistory.splice(removeIndex, 1)[0];
      if (removed && removed.previewUrl !== this.room.previewUrl) this.releasePreview(removed.previewUrl, false);
    }
  };

  AiSceneGenerator.prototype.syncRoomUploadToHistory = function () {
    this.uploadHistory.forEach(function (item) {
      if (!item || item.previewUrl !== this.room.previewUrl) return;
      item.objectKey = this.room.objectKey;
      item.uploadSessionId = this.room.uploadSessionId;
      item.identityGeneration = this.room.identityGeneration;
      item.file = this.room.file || item.file || null;
    }, this);
  };

  AiSceneGenerator.prototype.assertCurrentUploadIdentity = function (auth) {
    if (auth && auth.identityGeneration === currentIdentityGeneration()) return;
    this.uploadAuth = null;
    var error = new Error('The room image could not be uploaded. Please try again.');
    error.aiScenePhase = 'upload';
    throw error;
  };

  AiSceneGenerator.prototype.releasePreview = function (url, force) {
    if (!url || (this.uploadHistory.some(function (item) { return item.previewUrl === url; }) && !force)) return;
    if (String(url).indexOf('blob:') === 0) URL.revokeObjectURL(url);
  };

  AiSceneGenerator.prototype.setUploadStatus = function (message) {
    if (this.destroyed) return;
    if (this.nodes.uploadStatus) this.nodes.uploadStatus.textContent = message || '';
  };

  AiSceneGenerator.prototype.setUploadingState = function () {
    this.stopGenerationProgress(true);
    this.setBaseState('UPLOADING');
    this.setUploadStatus('Uploading…');
  };

  AiSceneGenerator.prototype.buildHeaders = async function (options) {
    this.assertActive();
    var settings = options || {};
    var headers = {};
    if (settings.json) headers['Content-Type'] = 'application/json';
    if (this.visitorToken) headers['X-Visitor-Token'] = this.visitorToken;
    if (settings.idempotencyKey) headers['Idempotency-Key'] = settings.idempotencyKey;
    return headers;
  };

  AiSceneGenerator.prototype.recoverVisitorAuthorization = async function (failedVisitorToken) {
    this.assertActive();
    var failedToken = String(failedVisitorToken || '');
    var currentToken = String(this.visitorToken || '');
    if (currentToken && currentToken !== failedToken) return;
    var storedToken = String(getStoredVisitorToken() || '');
    if (storedToken && storedToken !== failedToken) {
      this.visitorToken = storedToken;
      this.uploadAuth = null;
      return;
    }
    clearVisitorToken();
    this.visitorToken = '';
    this.uploadAuth = null;
    await this.ensureUploadAuthorization(true);
    this.assertActive();
  };

  AiSceneGenerator.prototype.endpoint = function (path) {
    var cleanPath = String(path || '').replace(/^\/+/, '');
    return this.apiBase + '/' + cleanPath;
  };

  AiSceneGenerator.prototype.resolveApiRequestUrl = function (value) {
    var parsed;
    var base;
    try {
      base = new URL(this.apiBase, window.location.origin);
      var requestBase = base.href.replace(/\/+$/, '') + '/';
      parsed = new URL(value, requestBase);
    } catch (error) {
      throw new Error('API endpoint is invalid.');
    }
    var basePath = (base.pathname || '').replace(/\/+$/, '') || '/';
    var requestPath = (parsed.pathname || '').replace(/\/+$/, '') || '/';
    var pathMatches = requestPath === basePath || requestPath.indexOf(basePath + '/') === 0;
    if (
      parsed.username ||
      parsed.password ||
      parsed.origin !== base.origin ||
      !pathMatches ||
      (parsed.origin !== window.location.origin && parsed.protocol !== 'https:')
    ) {
      throw new Error('API endpoint is not trusted.');
    }
    return parsed;
  };

  AiSceneGenerator.prototype.request = async function (path, options) {
    this.assertActive();
    var settings = options || {};
    var controller = new AbortController();
    this.abortControllers.add(controller);
    if (settings.signal) {
      if (settings.signal.aborted) controller.abort();
      settings.signal.addEventListener('abort', function () { controller.abort(); }, { once: true });
    }
    try {
      var requestUrl = this.resolveApiRequestUrl(settings.url || this.endpoint(path));
      var response = await fetch(requestUrl.href, {
        method: settings.method || 'GET',
        headers: settings.headers || {},
        body: settings.body,
        credentials: settings.credentials === 'omit' || requestUrl.origin !== window.location.origin ? 'omit' : 'same-origin',
        redirect: 'error',
        cache: 'no-store',
        signal: controller.signal
      });
      var text = await response.text();
      this.assertActive();
      var payload = parseResponseBody(text);
      if (!response.ok) throw createApiError(response.status, payload, 'Request failed.', response.headers);
      return { data: extractPayload(payload), raw: payload, response: response };
    } finally {
      this.abortControllers.delete(controller);
    }
  };

  AiSceneGenerator.prototype.ensureUploadAuthorization = function (force, identityRetried, tokenRetried) {
    if (this.uploadAuthorizationPromise) return this.uploadAuthorizationPromise;
    var self = this;
    var sharedPromise;
    var operation = this.requestUploadAuthorization(force, identityRetried, tokenRetried);
    sharedPromise = operation.then(function (authorization) {
      if (self.uploadAuthorizationPromise === sharedPromise) self.uploadAuthorizationPromise = null;
      return authorization;
    }, function (error) {
      if (self.uploadAuthorizationPromise === sharedPromise) self.uploadAuthorizationPromise = null;
      throw error;
    });
    this.uploadAuthorizationPromise = sharedPromise;
    return sharedPromise;
  };

  AiSceneGenerator.prototype.requestUploadAuthorization = async function (force, identityRetried, tokenRetried) {
    this.assertActive();
    this.identityGeneration = currentIdentityGeneration();
    var storedVisitorToken = getStoredVisitorToken();
    if (storedVisitorToken !== this.visitorToken) {
      this.visitorToken = storedVisitorToken;
      this.uploadAuth = null;
    }
    var authIdentityMatches = this.uploadAuth && this.uploadAuth.identityGeneration === this.identityGeneration;
    if (!force && authIdentityMatches && this.visitorToken && Number.isFinite(this.uploadAuth.expiresAt) && this.uploadAuth.expiresAt - Date.now() > 60000) {
      return this.uploadAuth;
    }

    var body = { scene: 'ROOM_IMAGE' };
    if (!this.visitorToken) body.browserId = getBrowserId();
    var headers = await this.buildHeaders({ json: true });
    this.assertActive();
    try {
      var result = await this.request('upload-authorizations', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
      });
      this.assertActive();
      var data = result.data || {};
      if (data.visitorToken) {
        var nextVisitorToken = String(data.visitorToken).trim();
        if (nextVisitorToken) {
          this.visitorToken = nextVisitorToken;
          saveVisitorToken(this.visitorToken);
        }
      }
      var uploadSessionId = String(data.uploadSessionId || '').trim();
      var uploadUrlValue = String(data.uploadUrl || '').trim();
      var objectKeyPrefix = String(data.objectKeyPrefix || '').trim();
      if (!uploadSessionId || !uploadUrlValue || !objectKeyPrefix) {
        throw new Error('Upload authorization is incomplete.');
      }
      var expiresAt = Date.parse(data.expiresAt || '');
      if (!Number.isFinite(expiresAt)) throw new Error('Upload authorization is incomplete.');
      this.uploadAuth = {
        uploadSessionId: uploadSessionId,
        method: String(data.method || 'POST').trim().toUpperCase(),
        uploadUrl: uploadUrlValue,
        objectKeyPrefix: objectKeyPrefix,
        formFields: data.formFields && typeof data.formFields === 'object' ? data.formFields : {},
        expiresAt: expiresAt,
        constraints: data.constraints && typeof data.constraints === 'object' ? data.constraints : {},
        identityGeneration: this.identityGeneration
      };
      if (!this.visitorToken) throw new Error('Visitor authorization is unavailable.');
      return this.uploadAuth;
    } catch (error) {
      if (!tokenRetried && error && (error.code === 'VISITOR_TOKEN_INVALID' || error.code === 'VISITOR_TOKEN_REQUIRED')) {
        clearVisitorToken();
        this.visitorToken = '';
        this.uploadAuth = null;
        return this.requestUploadAuthorization(true, identityRetried, true);
      }
      if (!identityRetried && error && error.code === 'IDENTITY_BINDING_CONFLICT') {
        clearVisitorToken();
        this.visitorToken = '';
        this.uploadAuth = null;
        window.__blacklyteAiIdentityGeneration = currentIdentityGeneration() + 1;
        this.identityGeneration = currentIdentityGeneration();
        storageRemove(window.localStorage, BROWSER_STORAGE_KEY);
        window.__blacklyteAiBrowserId = '';
        getBrowserId();
        return this.requestUploadAuthorization(force, true, tokenRetried);
      }
      throw error;
    }
  };

  AiSceneGenerator.prototype.uploadRoomImage = async function (file, extension, auth) {
    this.assertActive();
    var uploadUrl;
    try {
      uploadUrl = new URL(auth.uploadUrl, window.location.origin);
    } catch (error) {
      throw new Error('Upload endpoint is invalid.');
    }
    if (
      uploadUrl.username ||
      uploadUrl.password ||
      (uploadUrl.protocol !== 'https:' && uploadUrl.origin !== window.location.origin)
    ) {
      throw new Error('Upload endpoint is invalid.');
    }
    var key = auth.objectKeyPrefix.replace(/\/+$/, '') + '/' + uuid() + '.' + extension;
    var method = String(auth.method || 'POST').trim().toUpperCase();
    if (method !== 'POST') {
      // The current API contract signs OSS PostObject requests. Do not silently
      // send a multipart body when a future contract returns another method.
      throw new Error('This upload method is not supported.');
    }
    var form = new FormData();
    var contentType = imageContentType(file, extension);
    if (!contentType) throw new Error('This image format is not supported.');
    Object.keys(auth.formFields || {}).forEach(function (field) {
      form.append(field, auth.formFields[field]);
    });
    form.append('key', key);
    form.append('Content-Type', contentType);
    var uploadFile = String(file.type || '').toLowerCase() === String(contentType).toLowerCase()
      ? file
      : file.slice(0, file.size, contentType);
    form.append('file', uploadFile, file.name || key.split('/').pop());
    var controller = new AbortController();
    this.abortControllers.add(controller);
    try {
      var response = await fetch(uploadUrl.href, {
        method: method,
        body: form,
        credentials: 'omit',
        redirect: 'error',
        signal: controller.signal
      });
      this.assertActive();
      if (response.status !== 204) {
        var uploadError = new Error('The room image could not be uploaded.');
        uploadError.invalidateUploadAuthorization = true;
        throw uploadError;
      }
      return key;
    } finally {
      this.abortControllers.delete(controller);
    }
  };

  AiSceneGenerator.prototype.friendlyError = function (error, kind) {
    if (!error) return kind === 'upload' ? 'The room image could not be uploaded.' : this.labels.failed;
    if (this.isDailyRateLimit(error)) return 'The daily matching limit has been reached. Please try again tomorrow.';
    var code = String(error.code || '');
    var known = {
      INVALID_UPLOAD: 'The room image is no longer available. Please upload it again.',
      ROOM_IMAGE_LIMIT_EXCEEDED: 'Please upload a single room photo.',
      ROOM_IMAGE_NOT_A_ROOM: 'Please upload a clear photo of an indoor room.',
      ROOM_IMAGE_CONTENT_VIOLATION: 'This room photo cannot be used for matching.',
      IMAGE_TOO_LARGE: 'This image is larger than the allowed limit.',
      UNSUPPORTED_IMAGE: 'This image format is not supported.',
      PRODUCT_REQUIRED: this.labels.noProduct,
      PRODUCT_TYPE_INVALID: 'One selected product type is not supported.',
      PRODUCT_URL_INVALID: 'One selected product link is unavailable.',
      PRODUCT_IMAGE_URL_INVALID: 'One selected product image is unavailable.',
      PRODUCT_IMAGE_INVALID: 'One selected product image is unavailable.',
      PRODUCT_IMAGE_FETCH_FAILED: 'One selected product image could not be loaded.',
      PRODUCT_IMAGE_COUNT_INVALID: 'One selected product does not contain the required number of images.',
      PRODUCT_ANGLE_INDEX_INVALID: 'One selected product contains invalid or incomplete angle indexes.',
      PROXY_SIGNATURE_INVALID: 'We could not verify this storefront request. Please refresh the page and try again.',
      VISITOR_TOKEN_REQUIRED: 'Please refresh the page and try again.',
      VISITOR_TOKEN_INVALID: 'Please refresh the page and try again.',
      VISITOR_DISABLED: 'AI matching is unavailable for guest visitors right now.',
      IP_BLOCKED: 'AI matching is unavailable from this network right now.',
      GENERATION_FORBIDDEN: 'You do not have access to this matching task.',
      GENERATION_NOT_FOUND: 'This matching task is no longer available. Please generate a new one.',
      IDEMPOTENCY_CONFLICT: 'The generation request changed while it was being retried. Please generate again.',
      IDENTITY_BINDING_CONFLICT: 'Your visitor session changed. Please refresh the page and try again.',
      GENERATION_IN_PROGRESS: 'Another matching task is still in progress. Please wait and try again.',
      RATE_LIMITED: 'Too many requests. Please wait a moment and try again.',
      CAPACITY_EXCEEDED: 'The matching service is busy. Please try again shortly.',
      PROVIDER_MODERATION_BLOCKED: 'This image cannot be used for matching.',
      PROVIDER_ERROR: this.labels.failed,
      GENERATION_TIMEOUT: 'Matching took too long. Please try again.',
      PROVIDER_RESULT_UNKNOWN: this.labels.unknown,
      GENERATION_CANCELLED: 'This matching task was cancelled. Please generate a new one.',
      FEATURE_DISABLED: 'This feature is temporarily unavailable.',
      SERVICE_UNAVAILABLE: 'The matching service is temporarily unavailable. Please try again shortly.'
    };
    if (known[code]) return known[code];
    if (kind === 'upload') return 'The room image could not be uploaded.';
    if (error.name === 'TypeError' || /failed to fetch|network/i.test(String(error.message || ''))) return this.labels.unknown;
    if (error.status >= 500) return this.labels.failed;
    return error.message || this.labels.failed;
  };

  AiSceneGenerator.prototype.showError = function (message, kind, retrySameRequest) {
    if (this.destroyed) return;
    this.errorMessage = message || (kind === 'upload' ? 'The room image could not be uploaded.' : this.labels.failed);
    var container = this.nodes.error;
    if (!container) return;
    container.replaceChildren();
    var text = createElement('span', '', this.errorMessage);
    container.appendChild(text);
    var retry = createElement('button', 'ai-scene-generator__error-retry', kind === 'upload' ? this.labels.chooseAlbum : this.labels.retry);
    retry.type = 'button';
    if (kind === 'upload') retry.dataset.retryUpload = 'true';
    else {
      retry.dataset.retryGeneration = 'true';
      if (retrySameRequest) retry.dataset.retrySameRequest = 'true';
    }
    container.appendChild(retry);
    container.hidden = false;
  };

  AiSceneGenerator.prototype.clearError = function () {
    this.errorMessage = '';
    if (this.nodes.error) {
      this.nodes.error.replaceChildren();
      this.nodes.error.hidden = true;
    }
  };

  AiSceneGenerator.prototype.currentPageReturnUrl = function () {
    return window.location.pathname + window.location.search + window.location.hash;
  };

  AiSceneGenerator.prototype.resolveLoginUrl = function () {
    if (!this.loginUrl) return '';
    try {
      var loginUrl = new URL(this.loginUrl, window.location.origin);
      if (loginUrl.protocol !== 'https:' && loginUrl.protocol !== 'http:') return '';
      if (
        loginUrl.origin === window.location.origin &&
        /\/account\/login\/?$/.test(loginUrl.pathname) &&
        !loginUrl.searchParams.has('return_url') &&
        !loginUrl.searchParams.has('return_to')
      ) {
        loginUrl.searchParams.set('return_url', this.currentPageReturnUrl());
      }
      return loginUrl.href;
    } catch (error) {
      return '';
    }
  };

  AiSceneGenerator.prototype.openInlineLogin = function () {
    if (!this.inlineLoginAvailable || this.customerLoggedIn || !document.body) return false;
    var sidebar = document.querySelector('[data-auth-sidebar]');
    var form = sidebar && sidebar.querySelector('form[action]');
    var emailInput = form && form.querySelector('[name="customer[email]"]');
    var passwordInput = form && form.querySelector('[name="customer[password]"]');
    if (!sidebar || !form || !emailInput || !passwordInput) return false;
    try {
      var formAction = new URL(form.action, window.location.origin);
      if (formAction.origin !== window.location.origin || !/\/account\/login\/?$/.test(formAction.pathname)) return false;
    } catch (error) {
      return false;
    }
    var returnInput = form.querySelector('input[name="return_url"], input[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_url';
      form.appendChild(returnInput);
    }
    returnInput.value = this.currentPageReturnUrl();
    document.body.classList.add('auth-sidebar-show');
    window.requestAnimationFrame(function () {
      if (emailInput && document.body.classList.contains('auth-sidebar-show')) emailInput.focus();
    });
    return true;
  };

  AiSceneGenerator.prototype.openDailyLimit = function () {
    if (!this.nodes.dailyLimitModal || !this.nodes.dailyLimitDialog || !this.nodes.dailyLimitLogin) return false;
    var loginUrl = this.resolveLoginUrl();
    if (!loginUrl) return false;
    if (this.overlayState === 'PRODUCT_SELECTOR_OPEN') this.closeSelector(false);
    if (this.overlayState === 'UPLOAD_DRAWER_OPEN') this.closeUploadDrawer(false);
    if (this.overlayState === 'EMAIL_DELIVERY_OPEN') this.closeEmailDelivery(false);
    this.overlayFocus = document.activeElement;
    this.nodes.dailyLimitLogin.href = loginUrl;
    this.nodes.dailyLimitModal.hidden = false;
    this.nodes.dailyLimitModal.setAttribute('aria-hidden', 'false');
    this.setOverlayState('DAILY_LIMIT_OPEN');
    showSelectorBodyClass(this);
    if (!this.overlayLock) {
      lockBodyScroll();
      this.overlayLock = true;
    }
    window.requestAnimationFrame(function () {
      if (this.destroyed || this.overlayState !== 'DAILY_LIMIT_OPEN' || this.nodes.dailyLimitModal.hidden) return;
      this.nodes.dailyLimitLogin.focus();
    }.bind(this));
    return true;
  };

  AiSceneGenerator.prototype.closeDailyLimit = function (restoreFocus) {
    if (!this.nodes.dailyLimitModal) return;
    var focusTarget = this.overlayFocus;
    this.nodes.dailyLimitModal.hidden = true;
    this.nodes.dailyLimitModal.setAttribute('aria-hidden', 'true');
    hideSelectorBodyClass(this);
    if (this.overlayState === 'DAILY_LIMIT_OPEN') this.clearOverlayState();
    if (this.overlayLock) {
      unlockBodyScroll();
      this.overlayLock = false;
    }
    if (restoreFocus) {
      if (focusTarget && document.contains(focusTarget) && !focusTarget.disabled) focusTarget.focus();
      else if (this.nodes.stage) this.nodes.stage.focus();
    }
    this.overlayFocus = null;
  };

  AiSceneGenerator.prototype.isDailyRateLimit = function (error) {
    var direct = extractError(error);
    var payload = error && error.payload ? extractError(error.payload) : {};
    var code = normalizeLimitField(error && error.code || direct.code || payload.code);
    var scope = normalizeLimitField(error && error.limitScope || direct.limitScope || payload.limitScope);
    var dimension = normalizeLimitField(error && error.limitDimension || direct.limitDimension || payload.limitDimension);
    var period = normalizeLimitField(error && error.limitPeriod || direct.limitPeriod || payload.limitPeriod);
    var scopeMatches = scope === 'UPLOAD' || scope === 'GENERATION';
    var dimensionMatches = dimension === 'IP' || dimension === 'BROWSER' || (this.customerLoggedIn && dimension === 'CUSTOMER');
    return code === 'RATE_LIMITED' && scopeMatches && dimensionMatches && period === 'DAY';
  };

  AiSceneGenerator.prototype.handleDailyGenerationLimit = function (error) {
    if (!this.isDailyRateLimit(error) || this.customerLoggedIn) return false;
    this.clearError();
    var details = extractError(error);
    var payloadDetails = error && error.payload ? extractError(error.payload) : {};
    var scope = normalizeLimitField(error && error.limitScope || details.limitScope || payloadDetails.limitScope);
    if (scope === 'UPLOAD' && this.nodes && this.nodes.uploadStatus) this.setUploadStatus('');
    this.setBaseState(this.hasRoomSource() ? 'READY' : 'FAILED');
    if (this.openInlineLogin()) return true;
    return this.openDailyLimit();
  };

  AiSceneGenerator.prototype.openSelector = function (type) {
    if (this.generationPending || this.baseState === 'PROCESSING' || this.baseState === 'UPLOADING') return;
    if (!this.nodes.productSelector || !this.nodes.selectorDialog) return;
    var switchingFromUpload = this.overlayState === 'UPLOAD_DRAWER_OPEN' || (this.nodes.uploadDrawer && !this.nodes.uploadDrawer.hidden);
    if (switchingFromUpload) {
      this.closeUploadDrawer(false);
    }
    this.overlayFocus = switchingFromUpload ? null : document.activeElement;
    this.selectorType = normalizeType(type) || 'CHAIR';
    this.draftSelections = cloneMap(this.selected);
    this.switchSelectorTab(this.selectorType);
    this.nodes.productSelector.hidden = false;
    this.nodes.productSelector.setAttribute('aria-hidden', 'false');
    this.setOverlayState('PRODUCT_SELECTOR_OPEN');
    showSelectorBodyClass(this);
    if (!this.overlayLock) {
      lockBodyScroll();
      this.overlayLock = true;
    }
    this.root.querySelectorAll('[data-mobile-open-products]').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
    window.requestAnimationFrame(function () {
      if (!this.destroyed && this.overlayState === 'PRODUCT_SELECTOR_OPEN' && !this.nodes.productSelector.hidden) this.nodes.selectorDialog.focus();
    }.bind(this));
  };

  AiSceneGenerator.prototype.switchSelectorTab = function (type) {
    var selectedType = normalizeType(type) || 'CHAIR';
    this.selectorType = selectedType;
    this.root.querySelectorAll('[data-selector-tab]').forEach(function (tab) {
      var active = normalizeType(tab.dataset.selectorTab) === selectedType;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.root.querySelectorAll('[data-selector-panel]').forEach(function (panel) {
      panel.hidden = normalizeType(panel.dataset.selectorPanel) !== selectedType;
    });
    this.renderProducts();
  };

  AiSceneGenerator.prototype.toggleDraftProduct = function (tile) {
    if (this.generationPending || this.baseState === 'PROCESSING') return;
    if (tile.disabled || tile.dataset.productAvailable !== 'true') return;
    var type = normalizeType(tile.dataset.productType);
    var optionKey = tile.dataset.productOptionKey || tile.dataset.blockId || '';
    var product = this.products.find(function (item) {
      return item.optionKey === optionKey && item.type === type;
    });
    if (!product || !product.available) return;
    var current = this.draftSelections.get(type);
    if (current && current.optionKey === product.optionKey) this.draftSelections.delete(type);
    else this.draftSelections.set(type, Object.assign({}, product));
    this.renderProducts();
  };

  AiSceneGenerator.prototype.confirmSelector = function () {
    if (this.generationPending || this.baseState === 'PROCESSING' || this.baseState === 'UPLOADING') return;
    var selectionChanged = !selectionMapsEqual(this.selected, this.draftSelections);
    this.selected = cloneMap(this.draftSelections);
    if (selectionChanged) {
      this.resultUrl = '';
      this.generation = null;
      this.resetResultActionState();
      if (this.hasRoomSource()) this.baseState = 'READY';
      else this.baseState = 'EMPTY';
    }
    this.closeSelector(true);
    this.clearError();
    this.switchMainTab('room', true);
  };

  AiSceneGenerator.prototype.closeSelector = function (restoreFocus) {
    if (!this.nodes.productSelector) return;
    var focusTarget = this.overlayFocus;
    this.nodes.productSelector.hidden = true;
    this.nodes.productSelector.setAttribute('aria-hidden', 'true');
    hideSelectorBodyClass(this);
    this.draftSelections = cloneMap(this.selected);
    this.root.querySelectorAll('[data-mobile-open-products]').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    if (this.overlayState === 'PRODUCT_SELECTOR_OPEN') this.clearOverlayState();
    if (this.overlayLock) {
      unlockBodyScroll();
      this.overlayLock = false;
    }
    if (restoreFocus) {
      if (focusTarget && document.contains(focusTarget) && !focusTarget.disabled && !(focusTarget.closest && focusTarget.closest('[hidden]'))) focusTarget.focus();
      else if (this.nodes.stage) this.nodes.stage.focus();
    }
    this.overlayFocus = null;
  };

  AiSceneGenerator.prototype.openUploadDrawer = function () {
    if (this.generationPending || this.baseState === 'PROCESSING' || this.baseState === 'UPLOADING') return;
    if (!this.nodes.uploadDrawer || !this.nodes.uploadDialog) return;
    var switchingFromSelector = this.overlayState === 'PRODUCT_SELECTOR_OPEN' || (this.nodes.productSelector && !this.nodes.productSelector.hidden);
    if (switchingFromSelector) {
      this.closeSelector(false);
    }
    this.overlayFocus = switchingFromSelector ? null : document.activeElement;
    this.pendingHistory = this.uploadHistory.find(function (item) { return item.previewUrl === this.room.previewUrl; }) || null;
    this.renderHistory();
    this.nodes.uploadDrawer.hidden = false;
    this.nodes.uploadDrawer.setAttribute('aria-hidden', 'false');
    this.setOverlayState('UPLOAD_DRAWER_OPEN');
    if (!this.overlayLock) {
      lockBodyScroll();
      this.overlayLock = true;
    }
    this.root.querySelectorAll('[data-mobile-open-upload], [data-mobile-more]').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
    window.requestAnimationFrame(function () {
      if (!this.destroyed && this.overlayState === 'UPLOAD_DRAWER_OPEN' && !this.nodes.uploadDrawer.hidden) this.nodes.uploadDialog.focus();
    }.bind(this));
  };

  AiSceneGenerator.prototype.confirmUploadDrawer = function () {
    if (this.generationPending || !this.hasRoomSource() || this.baseState === 'UPLOADING' || this.baseState === 'PROCESSING') return;
    this.closeUploadDrawer(true);
  };

  AiSceneGenerator.prototype.closeUploadDrawer = function (restoreFocus) {
    if (!this.nodes.uploadDrawer) return;
    var focusTarget = this.overlayFocus;
    this.nodes.uploadDrawer.hidden = true;
    this.nodes.uploadDrawer.setAttribute('aria-hidden', 'true');
    this.pendingHistory = null;
    this.root.querySelectorAll('[data-mobile-open-upload], [data-mobile-more]').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    if (this.overlayState === 'UPLOAD_DRAWER_OPEN') this.clearOverlayState();
    if (this.overlayLock) {
      unlockBodyScroll();
      this.overlayLock = false;
    }
    if (restoreFocus) {
      if (focusTarget && document.contains(focusTarget) && !focusTarget.disabled && !(focusTarget.closest && focusTarget.closest('[hidden]'))) focusTarget.focus();
      else if (this.nodes.stage) this.nodes.stage.focus();
    }
    this.overlayFocus = null;
  };

  AiSceneGenerator.prototype.setEmailDeliveryStatus = function (message, state) {
    if (!this.nodes.emailDeliveryStatus) return;
    this.nodes.emailDeliveryStatus.textContent = message || '';
    this.nodes.emailDeliveryStatus.dataset.status = state || '';
    this.nodes.emailDeliveryStatus.hidden = !message;
  };

  AiSceneGenerator.prototype.openEmailDelivery = function () {
    var taskId = String(this.generation && this.generation.taskId || '').trim();
    if (this.baseState !== 'SUCCEEDED' || !this.resultUrl || !taskId || this.emailDeliveryPending) return;
    if (!this.nodes.emailDeliveryModal || !this.nodes.emailDeliveryDialog) return;
    if (this.overlayState === 'PRODUCT_SELECTOR_OPEN') this.closeSelector(false);
    if (this.overlayState === 'UPLOAD_DRAWER_OPEN') this.closeUploadDrawer(false);
    this.overlayFocus = document.activeElement;
    this.setEmailDeliveryStatus('', '');
    this.nodes.emailDeliveryModal.hidden = false;
    this.nodes.emailDeliveryModal.setAttribute('aria-hidden', 'false');
    this.setOverlayState('EMAIL_DELIVERY_OPEN');
    showSelectorBodyClass(this);
    if (!this.overlayLock) {
      lockBodyScroll();
      this.overlayLock = true;
    }
    window.requestAnimationFrame(function () {
      if (this.destroyed || this.overlayState !== 'EMAIL_DELIVERY_OPEN' || this.nodes.emailDeliveryModal.hidden) return;
      if (this.nodes.emailDeliveryInput) this.nodes.emailDeliveryInput.focus();
      else this.nodes.emailDeliveryDialog.focus();
    }.bind(this));
  };

  AiSceneGenerator.prototype.closeEmailDelivery = function (restoreFocus) {
    if (!this.nodes.emailDeliveryModal) return;
    var focusTarget = this.overlayFocus;
    this.nodes.emailDeliveryModal.hidden = true;
    this.nodes.emailDeliveryModal.setAttribute('aria-hidden', 'true');
    hideSelectorBodyClass(this);
    if (this.overlayState === 'EMAIL_DELIVERY_OPEN') this.clearOverlayState();
    if (this.overlayLock) {
      unlockBodyScroll();
      this.overlayLock = false;
    }
    if (restoreFocus) {
      if (focusTarget && document.contains(focusTarget) && !focusTarget.disabled) focusTarget.focus();
      else if (this.nodes.stage) this.nodes.stage.focus();
    }
    this.overlayFocus = null;
  };

  AiSceneGenerator.prototype.friendlyEmailDeliveryError = function (error) {
    var code = String(error && error.code || '');
    var known = {
      EMAIL_INVALID: 'Enter a valid email address.',
      GENERATION_NOT_DELIVERABLE: 'This result is not available for email delivery.',
      GENERATION_FORBIDDEN: 'You do not have access to this matching result.',
      GENERATION_NOT_FOUND: 'This matching result is no longer available.',
      RATE_LIMITED: 'Too many email requests. Please wait and try again.',
      SERVICE_UNAVAILABLE: 'Email delivery is temporarily unavailable. Please try again shortly.'
    };
    if (known[code]) return known[code];
    if (error && (error.name === 'TypeError' || /failed to fetch|network/i.test(String(error.message || '')))) {
      return 'Email delivery could not be confirmed. Please try again.';
    }
    return String(error && error.message || 'Email delivery failed. Please try again.');
  };

  AiSceneGenerator.prototype.deliverResultEmail = async function (email, taskId, tokenRetried) {
    this.assertActive();
    var requestedTaskId = String(taskId || '').trim();
    if (!requestedTaskId) throw new Error('This matching result is not ready for email delivery.');
    var requestVisitorToken = String(this.visitorToken || '');
    var headers = await this.buildHeaders({ json: true });
    this.assertActive();
    try {
      var result = await this.request('generations/' + encodeURIComponent(requestedTaskId) + '/email-deliveries', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ email: email })
      });
      if (result.response.status !== 202) throw new Error('Email delivery was not accepted.');
      return result.data || {};
    } catch (error) {
      if (!tokenRetried && error && (error.code === 'VISITOR_TOKEN_INVALID' || error.code === 'VISITOR_TOKEN_REQUIRED')) {
        await this.recoverVisitorAuthorization(requestVisitorToken);
        return this.deliverResultEmail(email, requestedTaskId, true);
      }
      throw error;
    }
  };

  AiSceneGenerator.prototype.submitEmailDelivery = async function () {
    if (this.emailDeliveryPending || !this.nodes.emailDeliveryInput) return;
    var input = this.nodes.emailDeliveryInput;
    var email = String(input.value || '').trim();
    if (!email || !input.checkValidity()) {
      input.reportValidity();
      return;
    }
    var taskId = String(this.generation && this.generation.taskId || '').trim();
    if (this.baseState !== 'SUCCEEDED' || !this.resultUrl || !taskId) return;
    this.emailDeliveryPending = true;
    this.setEmailDeliveryStatus('', '');
    this.updateControls();
    try {
      await this.deliverResultEmail(email, taskId, false);
      this.assertActive();
      if (String(this.generation && this.generation.taskId || '').trim() === taskId) {
        this.setEmailDeliveryStatus(this.labels.emailSent, 'success');
      }
    } catch (error) {
      if (isAbortError(error) || this.destroyed) return;
      if (String(this.generation && this.generation.taskId || '').trim() === taskId) {
        this.setEmailDeliveryStatus(this.friendlyEmailDeliveryError(error), 'error');
      }
    } finally {
      this.emailDeliveryPending = false;
      if (!this.destroyed) this.updateControls();
    }
  };

  AiSceneGenerator.prototype.setPanelActionStatus = function (message, state) {
    if (!this.nodes.panelActionStatus) return;
    this.nodes.panelActionStatus.textContent = message || '';
    this.nodes.panelActionStatus.dataset.status = state || '';
    this.nodes.panelActionStatus.hidden = !message;
  };

  AiSceneGenerator.prototype.resetResultActionState = function () {
    this.setPanelActionStatus('', '');
    this.setEmailDeliveryStatus('', '');
  };

  AiSceneGenerator.prototype.buildResultCartItems = function () {
    var generation = this.generation || {};
    var products = Array.isArray(generation.selectedProducts) ? generation.selectedProducts : [];
    if ((generation.sourceTab !== 'room' && generation.sourceTab !== 'cart') || !products.length) {
      return { items: [], complete: false };
    }
    var items = [];
    var seen = new Set();
    var complete = true;
    products.forEach(function (product) {
      var variantId = String(product && product.variantId || '').trim();
      if (!/^\d+$/.test(variantId) || !product.purchasable) {
        complete = false;
        return;
      }
      if (seen.has(variantId)) return;
      seen.add(variantId);
      var item = { id: variantId, quantity: 1 };
      var preorderInfo = String(product.preorderInfo || '').trim();
      if (preorderInfo && typeof window.extractAndFormatDate === 'function') {
        try {
          var preorderDate = window.extractAndFormatDate(preorderInfo);
          if (preorderDate) item.properties = { 'Pre-order': preorderDate };
        } catch (error) {
          // A malformed optional preorder metafield must not block cart addition.
        }
      }
      items.push(item);
    });
    return { items: items, complete: complete && items.length > 0 };
  };

  AiSceneGenerator.prototype.resolveCartUrl = function (routeName, fallbackPath) {
    var configured = window.routes && typeof window.routes[routeName] === 'string' ? window.routes[routeName] : '';
    if (!configured) {
      var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : (window.routes && window.routes.root ? window.routes.root : '/');
      configured = String(routeRoot).replace(/\/?$/, '/') + String(fallbackPath || '').replace(/^\/+/, '');
    }
    var parsed = new URL(configured, window.location.origin);
    if (parsed.origin !== window.location.origin || parsed.username || parsed.password) {
      throw new Error('The cart endpoint is invalid.');
    }
    return parsed.href;
  };

  AiSceneGenerator.prototype.applyThemeCartState = function (cart) {
    if (!cart || typeof cart !== 'object') return;
    var sidebar = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (sidebar && typeof window.updateSidebarCart === 'function') {
      if (document.body) document.body.classList.add('cart-sidebar-show');
      window.updateSidebarCart(cart);
      return;
    }
    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      element.textContent = String(Number(cart.item_count) || 0);
    });
    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
  };

  AiSceneGenerator.prototype.refreshThemeCart = function () {
    var self = this;
    return new Promise(function (resolve) {
      if (window.Shopify && typeof window.Shopify.getCart === 'function') {
        var settled = false;
        var timeout = window.setTimeout(function () { finish(null); }, THEME_CART_REFRESH_TIMEOUT_MS);
        var finish = function (cart) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeout);
          try {
            if (cart) self.applyThemeCartState(cart);
          } finally {
            resolve(cart || null);
          }
        };
        try {
          window.Shopify.getCart(finish);
        } catch (error) {
          finish(null);
        }
        return;
      }
      var cartUrl;
      try {
        cartUrl = self.resolveCartUrl('cart', 'cart.js');
        var parsed = new URL(cartUrl);
        if (!/\.js$/i.test(parsed.pathname)) parsed.pathname = parsed.pathname.replace(/\/+$/, '') + '.js';
        cartUrl = parsed.href;
      } catch (error) {
        resolve(null);
        return;
      }
      var controller = new AbortController();
      var fallbackTimeout = window.setTimeout(function () {
        controller.abort();
      }, THEME_CART_REFRESH_TIMEOUT_MS);
      self.abortControllers.add(controller);
      fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) { if (cart) self.applyThemeCartState(cart); })
        .catch(function () {})
        .finally(function () {
          window.clearTimeout(fallbackTimeout);
          self.abortControllers.delete(controller);
          resolve(null);
        });
    });
  };

  AiSceneGenerator.prototype.addSelectedProductsToCart = async function () {
    if (this.cartAddPending || this.destroyed) return;
    var taskId = String(this.generation && this.generation.taskId || '').trim();
    var cartPayload = this.buildResultCartItems();
    if (this.baseState !== 'SUCCEEDED' || !taskId || !cartPayload.complete || !cartPayload.items.length) {
      this.setPanelActionStatus('One or more selected products are unavailable for cart addition.', 'error');
      return;
    }
    this.cartAddPending = true;
    this.setPanelActionStatus('', '');
    this.updateControls();
    var controller = new AbortController();
    this.abortControllers.add(controller);
    try {
      var response = await fetch(this.resolveCartUrl('cart_add_url', 'cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartPayload.items }),
        credentials: 'same-origin',
        redirect: 'error',
        signal: controller.signal
      });
      var text = await response.text();
      var payload = parseResponseBody(text);
      if (!response.ok) {
        throw new Error(String(payload.description || payload.message || 'Unable to add the selected products to cart.'));
      }
      this.assertActive();
      await this.refreshThemeCart();
    } catch (error) {
      if (
        !isAbortError(error) &&
        !this.destroyed &&
        String(this.generation && this.generation.taskId || '').trim() === taskId
      ) {
        this.setPanelActionStatus(error.message || 'Unable to add the selected products to cart.', 'error');
      }
    } finally {
      this.abortControllers.delete(controller);
      this.cartAddPending = false;
      if (!this.destroyed) this.updateControls();
    }
  };

  AiSceneGenerator.prototype.restoreHistoryProductSelections = function (products) {
    var historyProducts = Array.isArray(products) ? products : [];
    var namesByType = new Map();
    var unsafeTypes = new Set();
    historyProducts.forEach(function (product) {
      var type = normalizeType(product && product.type);
      var name = historyProductNameKey(product && product.name);
      if (!type || !name) return;
      // A 256-character API value may be a truncated product name rather than
      // a complete identity, so it cannot safely drive an automatic restore.
      if (name.length >= 256) {
        unsafeTypes.add(type);
        return;
      }
      if (!namesByType.has(type)) namesByType.set(type, new Set());
      namesByType.get(type).add(name);
    });
    var selections = new Map();
    TYPE_ORDER.forEach(function (type) {
      if (unsafeTypes.has(type)) return;
      var names = namesByType.get(type);
      if (!names || names.size !== 1) return;
      var historyName = Array.from(names)[0];
      var matches = this.products.filter(function (product) {
        return (
          product &&
          product.type === type &&
          historyProductNameKey(product.name) === historyName
        );
      });
      if (matches.length === 1 && matches[0].available) {
        selections.set(type, Object.assign({}, matches[0]));
      }
    }, this);
    this.selected = selections;
    this.draftSelections = cloneMap(selections);
    var firstSelectedType = TYPE_ORDER.find(function (type) { return selections.has(type); });
    if (firstSelectedType) this.selectorType = firstSelectedType;
    return selections.size;
  };

  AiSceneGenerator.prototype.restoreHistoryCartSelections = function (products) {
    var historyProducts = Array.isArray(products) ? products : [];
    var selections = new Map();
    TYPE_ORDER.forEach(function (type) {
      var historyMatches = historyProducts.filter(function (product) {
        return normalizeType(product && product.type) === type;
      });
      if (historyMatches.length !== 1) return;
      var historyProduct = historyMatches[0];
      var optionKey = String(historyProduct.optionKey || '');
      var lineKey = String(historyProduct.lineKey || '');
      var variantId = String(historyProduct.variantId || '');
      var hasStrongIdentity = Boolean(optionKey || lineKey || /^\d+$/.test(variantId));
      var matches = this.cartProducts.filter(function (product) {
        if (!product || !product.available || product.type !== type) return false;
        if (optionKey && product.optionKey === optionKey) return true;
        if (lineKey && product.lineKey === lineKey) return true;
        return false;
      });
      if (!matches.length && /^\d+$/.test(variantId)) {
        matches = this.cartProducts.filter(function (product) {
          return product && product.available && product.type === type && product.variantId === variantId;
        });
      }
      if (!matches.length && !hasStrongIdentity) {
        var historyName = historyProductNameKey(historyProduct.name);
        if (historyName && historyName.length < 256) {
          matches = this.cartProducts.filter(function (product) {
            return product &&
              product.available &&
              product.type === type &&
              historyProductNameKey(product.name) === historyName;
          });
        }
      }
      if (matches.length === 1) selections.set(type, Object.assign({}, matches[0]));
    }, this);
    this.cartSelections = selections;
    return selections.size;
  };

  AiSceneGenerator.prototype.selectGenerationHistory = function (index) {
    if (this.generationPending || this.baseState === 'PROCESSING' || this.baseState === 'UPLOADING') return;
    var item = this.generationHistory[index];
    if (!item || item.status !== 'SUCCEEDED' || !item.taskId || !normalizeHttpsUrl(item.resultImageUrl)) return;
    var restoredProducts = [];
    var restoredSourceTab = 'history';
    var isCartHistory = item.sourceTab === 'cart' && Array.isArray(item.selectedProducts) && item.selectedProducts.length;
    if (isCartHistory) {
      this.restoreHistoryCartSelections(item.selectedProducts);
      restoredProducts = item.selectedProducts.map(function (product) {
        return Object.assign({}, product);
      });
      restoredSourceTab = 'cart';
      if (this.mainTab !== 'cart') this.switchMainTab('cart', true);
    }
    if (!isCartHistory) {
      if (this.mainTab !== 'room') this.switchMainTab('room', true);
      this.restoreHistoryProductSelections(item.products);
      restoredProducts = this.getRoomGenerationProducts().map(function (product) {
        return Object.assign({}, product);
      });
      if (restoredProducts.length) restoredSourceTab = 'room';
    }
    this.resultUrl = item.resultImageUrl;
    this.generation = {
      taskId: item.taskId,
      idempotencyKey: '',
      payload: null,
      origin: 'history',
      sourceTab: restoredSourceTab,
      selectedProducts: restoredProducts,
      location: ''
    };
    this.resetResultActionState();
    this.clearError();
    this.setBaseState('SUCCEEDED');
  };

  AiSceneGenerator.prototype.selectHistory = function (index) {
    if (this.generationPending || this.baseState === 'PROCESSING' || this.baseState === 'UPLOADING') return;
    var item = this.uploadHistory[index];
    if (!item || (!item.file && !(item.objectKey && item.uploadSessionId))) return;
    if (this.room.previewUrl && this.room.previewUrl !== item.previewUrl) this.addHistory(this.room, item.previewUrl);
    this.releasePreview(this.room.previewUrl, false);
    this.pendingHistory = item;
    this.room = {
      previewUrl: item.previewUrl,
      objectKey: item.objectKey,
      uploadSessionId: item.uploadSessionId || '',
      identityGeneration: item.identityGeneration,
      fileName: item.fileName || 'Room photo',
      file: item.file || null
    };
    this.resultUrl = '';
    this.generation = null;
    this.resetResultActionState();
    this.clearError();
    this.setBaseState('READY');
    this.setUploadStatus('Previous photo selected.');
    this.renderHistory();
  };

  AiSceneGenerator.prototype.switchMainTab = function (tabName, force) {
    if (!force && (this.generationPending || this.baseState === 'UPLOADING' || this.baseState === 'PROCESSING')) return;
    var tab = tabName === 'cart' ? 'cart' : 'room';
    var changed = this.mainTab !== tab;
    this.mainTab = tab;
    this.root.querySelectorAll('[data-main-tab]').forEach(function (button) {
      var active = button.dataset.mainTab === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
    });
    this.root.querySelectorAll('[data-main-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.mainPanel !== tab;
    });
    if (changed) {
      this.resultUrl = '';
      this.generation = null;
      this.resetResultActionState();
      if (this.hasRoomSource()) this.baseState = 'READY';
      else this.baseState = 'EMPTY';
      this.clearError();
    }
    if (tab === 'cart') this.cartRefreshDirty = true;
    this.renderAll();
    if (tab === 'cart') this.refreshCartProducts();
  };

  AiSceneGenerator.prototype.refreshCartProducts = async function () {
    if (this.destroyed) return;
    if (this.cartRefreshController) this.cartRefreshController.abort();
    var controller = new AbortController();
    this.cartRefreshController = controller;
    this.cartRefreshPending = true;
    this.cartRefreshDirty = true;
    this.deferredCartProducts = null;
    if (this.nodes.cartList) this.nodes.cartList.setAttribute('aria-busy', 'true');
    this.renderAll();
    try {
      var sectionUrl = new URL(window.location.href);
      sectionUrl.hash = '';
      sectionUrl.searchParams.set('section_id', this.sectionId);
      var response = await fetch(sectionUrl.href, {
        method: 'GET',
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Unable to refresh cart products.');
      var html = await response.text();
      if (controller.signal.aborted || this.destroyed) return;
      var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      var cartData = parsedDocument.querySelector('[data-cart-products]');
      if (!cartData) throw new Error('Cart product data is unavailable.');
      var nextProducts = this.parseCartProducts(cartData, true);
      this.cartRefreshDirty = false;
      this.setCartProducts(nextProducts);
    } catch (error) {
      if (!isAbortError(error) && this.cartRefreshController === controller) {
        // Keep the last snapshot visible, but block generation until a fresh
        // server-rendered cart (including product metafields) is available.
        this.cartRefreshDirty = true;
      }
    } finally {
      if (this.cartRefreshController === controller) {
        this.cartRefreshController = null;
        this.cartRefreshPending = false;
        if (this.nodes.cartList) this.nodes.cartList.removeAttribute('aria-busy');
        this.renderAll();
      }
    }
  };

  AiSceneGenerator.prototype.buildGenerationPayload = function () {
    if (
      this.identityGeneration !== currentIdentityGeneration() ||
      this.room.identityGeneration !== this.identityGeneration ||
      !this.visitorToken ||
      !this.room.objectKey ||
      !this.room.uploadSessionId
    ) return null;
    var products = this.getPayloadGenerationProducts();
    if (!products.length) return null;
    return {
      uploadSessionId: this.room.uploadSessionId,
      roomImages: [{ objectKey: this.room.objectKey }],
      products: products,
      extraRequirement: null
    };
  };

  AiSceneGenerator.prototype.assertGenerationPayload = function (payload) {
    if (!payload) return null;
    if (
      this.identityGeneration !== currentIdentityGeneration() ||
      !this.visitorToken ||
      !this.room.objectKey ||
      !this.room.uploadSessionId ||
      this.room.identityGeneration !== this.identityGeneration
    ) throw new Error('The generation context is incomplete.');
    if (
      payload.uploadSessionId !== this.room.uploadSessionId ||
      !payload.roomImages ||
      payload.roomImages.length !== 1 ||
      payload.roomImages[0].objectKey !== this.room.objectKey
    ) {
      throw new Error('The generation context is out of date. Please upload the room photo again.');
    }
    var products = Array.isArray(payload.products) ? payload.products : [];
    if (!products.length) {
      var productRequiredError = new Error(this.labels.noProduct);
      productRequiredError.code = 'PRODUCT_REQUIRED';
      productRequiredError.aiScenePhase = 'generation';
      throw productRequiredError;
    }
    var invalidType = products.some(function (product) { return !product || !normalizeType(product.type); });
    if (invalidType) {
      var productTypeError = new Error('One selected product type is not supported.');
      productTypeError.code = 'PRODUCT_TYPE_INVALID';
      productTypeError.aiScenePhase = 'generation';
      throw productTypeError;
    }
    var productsByType = { CHAIR: [], DESK: [], ACCESSORY: [] };
    products.forEach(function (product) {
      productsByType[normalizeType(product.type)].push(product);
    });
    var invalidProductCount = TYPE_ORDER.some(function (type) {
      var group = productsByType[type];
      return group.length > 0 && group.length !== requiredProductPayloadCount(type);
    });
    if (invalidProductCount) {
      var productCountError = new Error('One selected product does not contain the required number of images.');
      productCountError.code = 'PRODUCT_IMAGE_COUNT_INVALID';
      productCountError.aiScenePhase = 'generation';
      throw productCountError;
    }
    var invalidAngleIndex = TYPE_ORDER.some(function (type) {
      var group = productsByType[type];
      if (!group.length) return false;
      var expectedCount = requiredProductPayloadCount(type);
      var seenAngles = new Set();
      var hasInvalidAngle = group.some(function (product) {
        var angleIndex = product.angleIndex;
        var valid = (
          typeof angleIndex === 'number' &&
          Number.isFinite(angleIndex) &&
          Math.floor(angleIndex) === angleIndex &&
          angleIndex >= 0 &&
          angleIndex < expectedCount &&
          !seenAngles.has(angleIndex)
        );
        if (valid) seenAngles.add(angleIndex);
        return !valid;
      });
      return hasInvalidAngle || seenAngles.size !== expectedCount;
    });
    if (invalidAngleIndex) {
      var productAngleError = new Error('One selected product contains invalid or incomplete angle indexes.');
      productAngleError.code = 'PRODUCT_ANGLE_INDEX_INVALID';
      productAngleError.aiScenePhase = 'generation';
      throw productAngleError;
    }
    var invalidImage = products.some(function (product) {
      return !String(product.name || '').trim() || !normalizeHttpsUrl(product.imageUrl);
    });
    if (invalidImage) {
      var productImageError = new Error('One selected product image is unavailable.');
      productImageError.code = 'PRODUCT_IMAGE_URL_INVALID';
      productImageError.aiScenePhase = 'generation';
      throw productImageError;
    }
    var invalidProductUrl = products.some(function (product) {
      return !normalizeStorefrontProductUrl(product.productUrl, this.shopUrl);
    }, this);
    if (invalidProductUrl) {
      var productUrlError = new Error('One selected product link is unavailable.');
      productUrlError.code = 'PRODUCT_URL_INVALID';
      productUrlError.aiScenePhase = 'generation';
      throw productUrlError;
    }
    return payload;
  };

  AiSceneGenerator.prototype.prepareGenerationPayload = async function () {
    this.assertActive();
    this.identityGeneration = currentIdentityGeneration();
    var sharedVisitorToken = getStoredVisitorToken();
    if (sharedVisitorToken !== this.visitorToken) {
      this.visitorToken = sharedVisitorToken;
      this.uploadAuth = null;
    }
    if (
      this.visitorToken &&
      this.room.identityGeneration === this.identityGeneration &&
      this.hasUploadedRoom()
    ) {
      return this.assertGenerationPayload(this.buildGenerationPayload());
    }

    var previousRoom = Object.assign({}, this.room);
    if (!previousRoom.file && !(previousRoom.objectKey && previousRoom.uploadSessionId)) {
      var missingRoomError = new Error('Please select a room photo before generating.');
      missingRoomError.aiScenePhase = 'upload';
      throw missingRoomError;
    }
    this.setUploadingState();
    var refreshedAuth;
    try {
      refreshedAuth = await this.ensureUploadAuthorization();
      this.assertActive();
    } catch (error) {
      throw tagError(error, 'upload');
    }
    if (
      previousRoom.uploadSessionId &&
      previousRoom.objectKey &&
      previousRoom.identityGeneration === this.identityGeneration
    ) {
      // Refreshing the visitor credential does not invalidate an uploaded object.
      this.room = previousRoom;
    } else if (previousRoom.file) {
      var extension = String(previousRoom.file.name || '').split('.').pop().toLowerCase();
      var validation = this.validateFile(previousRoom.file, refreshedAuth.constraints);
      if (!validation.ok) {
        var validationError = new Error(validation.message);
        validationError.aiScenePhase = 'upload';
        throw validationError;
      }
      var refreshedKey;
      try {
        refreshedKey = await this.uploadRoomImage(previousRoom.file, validation.extension || extension, refreshedAuth);
        this.assertActive();
      } catch (error) {
        if (error && error.invalidateUploadAuthorization) this.uploadAuth = null;
        throw tagError(error, 'upload');
      }
      this.assertCurrentUploadIdentity(refreshedAuth);
      this.room.objectKey = refreshedKey;
      this.room.uploadSessionId = refreshedAuth.uploadSessionId;
      this.room.identityGeneration = refreshedAuth.identityGeneration;
      this.room.file = previousRoom.file;
      this.syncRoomUploadToHistory();
      this.setBaseState('READY');
      this.setUploadStatus('Upload complete.');
    } else {
      var sessionError = new Error('The upload session expired. Please upload the room photo again.');
      sessionError.aiScenePhase = 'upload';
      throw sessionError;
    }
    var preparedPayload = this.assertGenerationPayload(this.buildGenerationPayload());
    if (!preparedPayload) {
      this.uploadAuth = null;
      var preparedContextError = new Error(
        this.visitorToken
          ? 'The room image context changed. Please try generating again.'
          : 'Visitor authorization is unavailable.'
      );
      preparedContextError.aiScenePhase = 'upload';
      throw preparedContextError;
    }
    return preparedPayload;
  };

  AiSceneGenerator.prototype.refreshGenerationContext = async function () {
    this.assertActive();
    this.identityGeneration = currentIdentityGeneration();
    var previousRoom = Object.assign({}, this.room);
    clearVisitorToken();
    this.visitorToken = '';
    this.uploadAuth = null;
    this.setUploadingState();
    var refreshedAuth;
    try {
      refreshedAuth = await this.ensureUploadAuthorization(true);
      this.assertActive();
    } catch (error) {
      throw tagError(error, 'upload');
    }
    if (
      previousRoom.uploadSessionId &&
      previousRoom.objectKey &&
      previousRoom.identityGeneration === this.identityGeneration
    ) {
      // Preserve the session that owns the object; only the visitor credential changed.
      this.room = previousRoom;
    } else if (previousRoom.file) {
      var validation = this.validateFile(previousRoom.file, refreshedAuth.constraints);
      if (!validation.ok) {
        var validationError = new Error(validation.message);
        validationError.aiScenePhase = 'upload';
        throw validationError;
      }
      var refreshedKey;
      try {
        refreshedKey = await this.uploadRoomImage(previousRoom.file, validation.extension, refreshedAuth);
        this.assertActive();
      } catch (error) {
        if (error && error.invalidateUploadAuthorization) this.uploadAuth = null;
        throw tagError(error, 'upload');
      }
      this.assertCurrentUploadIdentity(refreshedAuth);
      this.room.objectKey = refreshedKey;
      this.room.uploadSessionId = refreshedAuth.uploadSessionId;
      this.room.identityGeneration = refreshedAuth.identityGeneration;
      this.room.file = previousRoom.file;
      this.syncRoomUploadToHistory();
      this.setBaseState('READY');
      this.setUploadStatus('Upload complete.');
    } else {
      var refreshSessionError = new Error('The upload session expired. Please upload the room photo again.');
      refreshSessionError.aiScenePhase = 'upload';
      throw refreshSessionError;
    }
    var refreshedPayload;
    try {
      refreshedPayload = this.assertGenerationPayload(this.buildGenerationPayload());
    } catch (error) {
      throw tagError(error, error && error.aiScenePhase ? error.aiScenePhase : 'upload');
    }
    if (!refreshedPayload) {
      if (!this.visitorToken) {
        var visitorError = new Error('Visitor authorization is unavailable.');
        visitorError.aiScenePhase = 'upload';
        throw visitorError;
      }
      var contextError = new Error('The generation context could not be refreshed. Please upload the room photo again.');
      contextError.aiScenePhase = 'upload';
      throw contextError;
    }
    this.startGenerationProgress();
    this.setBaseState('PROCESSING');
    return refreshedPayload;
  };

  AiSceneGenerator.prototype.finishGeneration = function () {
    this.generationPending = false;
    this.stopGenerationProgress(true);
    if (this.nodes.generationProgressStatus && this.baseState !== 'SUCCEEDED') {
      this.nodes.generationProgressStatus.textContent = '';
    }
    this.pendingGenerationProducts = null;
    if (this.destroyed) {
      this.deferredCartProducts = null;
      return;
    }
    if (!this.cartRefreshPending && !this.cartRefreshDirty) this.commitDeferredCartProducts();
    this.renderAll();
    if (!this.destroyed && this.cartRefreshDirty && !this.cartRefreshPending) {
      this.refreshCartProducts();
    }
  };

  AiSceneGenerator.prototype.startGeneration = async function (newIdempotencyKey) {
    if (!this.canGenerate() || this.destroyed || this.generationPending) return;
    var retryGeneration = newIdempotencyKey === true ? null : this.generation;
    var sourceTab = this.mainTab;
    var selectedProducts = this.getActiveGenerationProducts().map(function (product) {
      return {
        optionKey: product.optionKey,
        lineKey: product.lineKey,
        type: product.type,
        name: product.name,
        title: product.title,
        variantTitle: product.variantTitle,
        imageUrl: product.imageUrl,
        spinImageUrls: normalizeSpinImageUrls(product.spinImageUrls),
        productUrl: product.productUrl,
        variantId: product.variantId,
        purchasable: Boolean(product.purchasable),
        preorderInfo: String(product.preorderInfo || '')
      };
    });
    this.pendingGenerationProducts = selectedProducts;
    this.generationPending = true;
    this.stopGenerationProgress(true);
    this.resetResultActionState();
    this.renderAll();
    this.clearError();
    var payload;
    try {
      payload = await this.prepareGenerationPayload();
    } catch (prepareError) {
      if (isAbortError(prepareError) || this.destroyed) {
        this.finishGeneration();
        return;
      }
      if (this.handleDailyGenerationLimit(prepareError)) {
        this.finishGeneration();
        return;
      }
      this.setBaseState('FAILED');
      var prepareKind = prepareError && prepareError.aiScenePhase === 'generation' ? 'generation' : 'upload';
      var prepareMessage = prepareError && prepareError.code
        ? this.friendlyError(prepareError, prepareKind)
        : (prepareError && prepareError.message ? prepareError.message : this.labels.failed);
      this.showError(prepareMessage, prepareKind);
      if (prepareKind === 'upload') this.setUploadStatus(prepareMessage);
      this.finishGeneration();
      return;
    }
    if (this.destroyed) {
      this.finishGeneration();
      return;
    }
    if (!payload) {
      this.showError(this.labels.noProduct, 'generation');
      this.finishGeneration();
      return;
    }
    var retryPayloadMatches = Boolean(
      retryGeneration &&
      retryGeneration.payload &&
      JSON.stringify(retryGeneration.payload) === JSON.stringify(payload)
    );
    var generationSourceTab = retryPayloadMatches && (retryGeneration.sourceTab === 'cart' || retryGeneration.sourceTab === 'room')
      ? retryGeneration.sourceTab
      : sourceTab;
    var generationSelectedProducts = retryPayloadMatches && Array.isArray(retryGeneration.selectedProducts)
      ? retryGeneration.selectedProducts.map(function (product) { return Object.assign({}, product); })
      : selectedProducts;
    var idempotencyKey = newIdempotencyKey === true
      ? uuid()
      : (
        typeof newIdempotencyKey === 'string' && newIdempotencyKey
          ? newIdempotencyKey
          : (retryPayloadMatches && retryGeneration.idempotencyKey ? retryGeneration.idempotencyKey : uuid())
      );
    this.generation = {
      taskId: retryPayloadMatches ? String(retryGeneration.taskId || '') : '',
      idempotencyKey: idempotencyKey,
      payload: payload,
      origin: 'live',
      sourceTab: generationSourceTab,
      selectedProducts: generationSelectedProducts,
      location: retryPayloadMatches ? String(retryGeneration.location || '') : ''
    };
    this.resultUrl = '';
    this.startGenerationProgress();
    this.setBaseState('PROCESSING');
    try {
      if (this.generation.taskId) {
        await this.pollGeneration(this.generation.taskId, DEFAULT_POLL_DELAY_SECONDS, this.generation.location);
        this.assertActive();
        return;
      }
      var created = await this.createGeneration(payload, idempotencyKey);
      this.assertActive();
      if (!created.taskId) {
        var missingTaskError = new Error('Generation task was not created.');
        missingTaskError.creationUnconfirmed = true;
        throw missingTaskError;
      }
      this.generation.taskId = created.taskId;
      this.generation.location = created.location || '';
      var firstDelay = asPositiveSeconds(created.pollAfterSeconds, this.retryAfter(created.headers, DEFAULT_POLL_DELAY_SECONDS));
      await this.pollGeneration(created.taskId, firstDelay, this.generation.location);
      this.assertActive();
    } catch (error) {
      if (isAbortError(error) || this.destroyed) return;
      if (this.handleDailyGenerationLimit(error)) return;
      var isUploadFailure = error && (
        error.aiScenePhase === 'upload' ||
        [
          'INVALID_UPLOAD',
          'ROOM_IMAGE_LIMIT_EXCEEDED',
          'ROOM_IMAGE_NOT_A_ROOM',
          'ROOM_IMAGE_CONTENT_VIOLATION',
          'IMAGE_TOO_LARGE',
          'UNSUPPORTED_IMAGE'
        ].indexOf(String(error.code || '')) >= 0
      );
      var isUnconfirmed = error && (
        error.creationUnconfirmed ||
        Number(error.status) >= 500 ||
        error.name === 'TypeError' ||
        /failed to fetch|network/i.test(String(error.message || ''))
      );
      var isRateLimited = Boolean(error && normalizeLimitField(error.code) === 'RATE_LIMITED');
      var retrySameRequest = Boolean(isUnconfirmed || (isRateLimited && !this.isDailyRateLimit(error)));
      this.setBaseState(isUploadFailure ? 'FAILED' : (isUnconfirmed ? 'UNKNOWN' : 'FAILED'));
      var errorKind = isUploadFailure ? 'upload' : 'generation';
      var errorMessage = this.friendlyError(error, errorKind);
      this.showError(errorMessage, errorKind, retrySameRequest);
      if (isUploadFailure) this.setUploadStatus(errorMessage);
    } finally {
      this.finishGeneration();
    }
  };

  AiSceneGenerator.prototype.createGeneration = async function (payload, idempotencyKey) {
    this.assertActive();
    var headers = await this.buildHeaders({ json: true, idempotencyKey: idempotencyKey });
    this.assertActive();
    try {
      var result = await this.request('generations', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload)
      });
      this.assertActive();
      var data = result.data || {};
      return {
        taskId: String(data.taskId || '').trim(),
        pollAfterSeconds: data.pollAfterSeconds,
        location: result.response.headers.get('Location') || '',
        headers: result.response.headers
      };
    } catch (error) {
      if (error && (error.code === 'VISITOR_TOKEN_INVALID' || error.code === 'VISITOR_TOKEN_REQUIRED')) {
        var refreshedPayload = await this.refreshGenerationContext();
        this.assertActive();
        var retryIdempotencyKey = idempotencyKey;
        if (JSON.stringify(payload) !== JSON.stringify(refreshedPayload)) {
          // A re-upload can change uploadSessionId/objectKey. Idempotency keys
          // may only be reused when the retried request has the same body.
          retryIdempotencyKey = uuid();
        }
        if (this.generation) {
          this.generation.payload = refreshedPayload;
          this.generation.idempotencyKey = retryIdempotencyKey;
        }
        this.setBaseState('PROCESSING');
        var retryHeaders = await this.buildHeaders({ json: true, idempotencyKey: retryIdempotencyKey });
        this.assertActive();
        var retryResult = await this.request('generations', {
          method: 'POST',
          headers: retryHeaders,
          body: JSON.stringify(refreshedPayload)
        });
        this.assertActive();
        var retryData = retryResult.data || {};
        return {
          taskId: String(retryData.taskId || '').trim(),
          pollAfterSeconds: retryData.pollAfterSeconds,
          location: retryResult.response.headers.get('Location') || '',
          headers: retryResult.response.headers
        };
      }
      throw error;
    }
  };

  AiSceneGenerator.prototype.retryAfter = function (headers, fallback) {
    if (!headers || typeof headers.get !== 'function') return fallback;
    var value = String(headers.get('Retry-After') || '').trim();
    if (!value) return fallback;
    if (/^\d+$/.test(value)) return Math.max(1, Number(value));
    var retryAt = Date.parse(value);
    if (Number.isFinite(retryAt)) {
      return Math.max(1, (retryAt - Date.now()) / 1000);
    }
    return fallback;
  };

  AiSceneGenerator.prototype.generationEndpoint = function (taskId, location) {
    if (location) {
      try {
        return this.resolveApiRequestUrl(location).href;
      } catch (error) {
        // Fall back to the canonical endpoint below.
      }
    }
    return this.endpoint('generations/' + encodeURIComponent(taskId));
  };

  AiSceneGenerator.prototype.pollGeneration = async function (taskId, delaySeconds, location) {
    this.assertActive();
    var controller = new AbortController();
    this.abortControllers.add(controller);
    var timedOut = false;
    var timeoutTimer = window.setTimeout(function () {
      timedOut = true;
      controller.abort();
    }, DEFAULT_GENERATION_POLL_TIMEOUT_MS);
    try {
      var delay = asPositiveSeconds(delaySeconds, DEFAULT_POLL_DELAY_SECONDS);
      var deadline = Date.now() + DEFAULT_GENERATION_POLL_TIMEOUT_MS;
      while (!controller.signal.aborted) {
        var remainingMs = deadline - Date.now();
        if (remainingMs <= 0) {
          this.setBaseState('UNKNOWN');
          this.showError(this.labels.unknown, 'generation', true);
          return;
        }
        await wait(Math.min(delay * 1000, remainingMs), controller.signal);
        this.assertActive();
        if (Date.now() >= deadline) {
          this.setBaseState('UNKNOWN');
          this.showError(this.labels.unknown, 'generation', true);
          return;
        }
        var headers = await this.buildHeaders({});
        this.assertActive();
        var result;
        try {
          result = await this.request('', {
            method: 'GET',
            url: this.generationEndpoint(taskId, location),
            headers: headers,
            signal: controller.signal
          });
          this.assertActive();
        } catch (error) {
          if (error && (error.code === 'VISITOR_TOKEN_INVALID' || error.code === 'VISITOR_TOKEN_REQUIRED')) {
            clearVisitorToken();
            this.visitorToken = '';
            this.uploadAuth = null;
            await this.ensureUploadAuthorization(true);
            this.assertActive();
            var retryHeaders = await this.buildHeaders({});
            this.assertActive();
            try {
              result = await this.request('', {
                method: 'GET',
                url: this.generationEndpoint(taskId, location),
                headers: retryHeaders,
                signal: controller.signal
              });
              this.assertActive();
            } catch (retryError) {
              if (retryError && normalizeLimitField(retryError.code) === 'RATE_LIMITED') {
                if (this.isDailyRateLimit(retryError)) {
                  if (this.handleDailyGenerationLimit(retryError)) return;
                  throw retryError;
                }
                delay = this.retryAfter(retryError.headers, DEFAULT_POLL_DELAY_SECONDS);
                continue;
              }
              if (
                retryError && (
                  Number(retryError.status) >= 500 ||
                  retryError.name === 'TypeError' ||
                  /failed to fetch|network/i.test(String(retryError.message || ''))
                )
              ) {
                delay = this.retryAfter(retryError.headers, DEFAULT_POLL_DELAY_SECONDS);
                continue;
              }
              throw retryError;
            }
          } else if (error && normalizeLimitField(error.code) === 'RATE_LIMITED') {
            if (this.isDailyRateLimit(error)) {
              if (this.handleDailyGenerationLimit(error)) return;
              throw error;
            }
            delay = this.retryAfter(error.headers, DEFAULT_POLL_DELAY_SECONDS);
            continue;
          } else if (
            error && (
              Number(error.status) >= 500 ||
              error.name === 'TypeError' ||
              /failed to fetch|network/i.test(String(error.message || ''))
            )
          ) {
            delay = this.retryAfter(error.headers, DEFAULT_POLL_DELAY_SECONDS);
            continue;
          } else {
            throw error;
          }
        }
        if (Date.now() >= deadline) {
          this.setBaseState('UNKNOWN');
          this.showError(this.labels.unknown, 'generation', true);
          return;
        }
        var data = result.data || {};
        if (data.taskId && String(data.taskId) !== taskId) {
          throw new Error('Generation task response does not match the requested task.');
        }
        var status = String(data.status || '').toUpperCase();
        if (status === 'PROCESSING') {
          delay = asPositiveSeconds(data.pollAfterSeconds, this.retryAfter(result.response.headers, DEFAULT_POLL_DELAY_SECONDS));
          continue;
        }
        if (status === 'SUCCEEDED') {
          var resultUrl = normalizeHttpsUrl(data.resultImageUrl);
          if (!resultUrl) {
            this.setBaseState('UNKNOWN');
            this.showError(this.labels.unknown, 'generation', true);
            return;
          }
          this.resultUrl = resultUrl;
          this.recordSuccessfulGeneration(data, resultUrl);
          window.clearTimeout(timeoutTimer);
          this.setGenerationProgress(100);
          if (this.nodes.generationProgressStatus) {
            this.nodes.generationProgressStatus.textContent = this.labels.success;
          }
          await wait(GENERATION_PROGRESS_COMPLETION_HOLD_MS, controller.signal);
          this.assertActive();
          this.setBaseState('SUCCEEDED');
          return;
        }
        if (status === 'FAILED') {
          var failureDetails = extractError(data);
          var failure = {
            code: failureDetails.code || data.errorCode,
            message: failureDetails.message,
            limitScope: failureDetails.limitScope,
            limitDimension: failureDetails.limitDimension,
            limitPeriod: failureDetails.limitPeriod
          };
          if (this.handleDailyGenerationLimit(failure)) return;
          var failureKind = [
            'INVALID_UPLOAD',
            'ROOM_IMAGE_LIMIT_EXCEEDED',
            'ROOM_IMAGE_NOT_A_ROOM',
            'ROOM_IMAGE_CONTENT_VIOLATION',
            'IMAGE_TOO_LARGE',
            'UNSUPPORTED_IMAGE'
          ].indexOf(String(failure.code || '')) >= 0 ? 'upload' : 'generation';
          this.setBaseState('FAILED');
          var failureMessage = this.friendlyError(failure, failureKind);
          this.showError(failureMessage, failureKind);
          if (failureKind === 'upload') this.setUploadStatus(failureMessage);
          return;
        }
        if (status === 'UNKNOWN') {
          var unknownDetails = extractError(data);
          var unknownFailure = {
            code: unknownDetails.code || data.errorCode,
            message: unknownDetails.message,
            limitScope: unknownDetails.limitScope,
            limitDimension: unknownDetails.limitDimension,
            limitPeriod: unknownDetails.limitPeriod
          };
          if (this.handleDailyGenerationLimit(unknownFailure)) return;
          this.setBaseState('UNKNOWN');
          this.showError(this.friendlyError(unknownFailure, 'generation'), 'generation');
          return;
        }
        this.setBaseState('UNKNOWN');
        this.showError(this.labels.unknown, 'generation', true);
        return;
      }
    } catch (error) {
      if (timedOut) {
        this.setBaseState('UNKNOWN');
        this.showError(this.labels.unknown, 'generation', true);
        return;
      }
      if (isAbortError(error)) throw error;
      if (this.handleDailyGenerationLimit(error)) return;
      if (error && (error.code || (Number(error.status) >= 400 && Number(error.status) < 500))) {
        this.setBaseState('FAILED');
        this.showError(this.friendlyError(error, 'generation'), 'generation');
        return;
      }
      this.setBaseState('UNKNOWN');
      this.showError(this.labels.unknown, 'generation', true);
      return;
    } finally {
      window.clearTimeout(timeoutTimer);
      this.abortControllers.delete(controller);
    }
  };

  AiSceneGenerator.prototype.destroy = function () {
    if (this.destroyed) return;
    this.stopGenerationProgress(false);
    this.stopProgressParticleField();
    this.destroyed = true;
    this.uploadRequestId += 1;
    this.stopProcessingTipCarousel(false);
    this.unbindThumbnailScroller();
    this.root.removeEventListener('click', this.onClickBound);
    this.root.removeEventListener('change', this.onChangeBound);
    this.root.removeEventListener('submit', this.onSubmitBound);
    this.root.removeEventListener('contextmenu', this.onGeneratedImageContextMenuBound);
    document.removeEventListener('keydown', this.onKeydownBound);
    document.removeEventListener('cart-update', this.onCartUpdateBound);
    this.unbindMobileViewport();
    if (this.cartRefreshController) {
      this.cartRefreshController.abort();
      this.cartRefreshController = null;
    }
    this.abortControllers.forEach(function (controller) { controller.abort(); });
    this.abortControllers.clear();
    hideSelectorBodyClass(this);
    hideMobileFullscreenBodyClass(this);
    if (this.overlayLock) {
      unlockBodyScroll();
      this.overlayLock = false;
    }
    var urls = [];
    if (this.room.previewUrl) urls.push(this.room.previewUrl);
    if (this.resultUrl) urls.push(this.resultUrl);
    this.uploadHistory.forEach(function (item) { if (item && item.previewUrl) urls.push(item.previewUrl); });
    urls.forEach(function (url) {
      if (String(url).indexOf('blob:') === 0) URL.revokeObjectURL(url);
    });
    instances.delete(this.sectionId);
    this.root.__aiSceneInstance = null;
  };

  function initRoot(root) {
    if (!root || root.__aiSceneInstance) return root && root.__aiSceneInstance;
    var sectionId = root.dataset.sectionId || root.id || uuid();
    var instance = new AiSceneGenerator(root);
    root.__aiSceneInstance = instance;
    instances.set(sectionId, instance);
    return instance;
  }

  function destroyRoot(root) {
    if (!root) return;
    var instance = root.__aiSceneInstance;
    if (instance) instance.destroy();
  }

  function initAll(scope) {
    var container = scope || document;
    if (container.matches && container.matches('[data-ai-scene-generator]')) initRoot(container);
    if (container.querySelectorAll) container.querySelectorAll('[data-ai-scene-generator]').forEach(initRoot);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    instances.forEach(function (instance) {
      instance.refreshMobileViewportObservers();
      instance.scheduleMobileViewportUpdate();
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findSectionRoot(event.target);
    destroyRoot(root);
    instances.forEach(function (instance) {
      instance.refreshMobileViewportObservers();
      instance.scheduleMobileViewportUpdate();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
})();
